$wj([62],{

/***/ 1711:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var defaultStore = {
    mruFolders: [],
    isInitialized: false,
};
exports.getStore = satcheljs_1.createStore('mruFolderCache', defaultStore);
var store = exports.getStore();
exports.default = store;
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 1720:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 2299));
});
exports.ProgressBar = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.ProgressBar; });
exports.BulkActionProgressBar = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.BulkActionProgressBar; });
exports.lazySubscribeToBulkActionNotification = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.subscribeToBulkActionNotification; });
exports.lazyOnBulkActionSubmitted = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.onBulkActionSubmitted; });
exports.lazyOnBulkActionFailure = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.onBulkActionFailure; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1840:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var getMoveToMruList_1 = __webpack_require__(1841);
exports.getMoveToMruList = getMoveToMruList_1.default;
owa_bundling_1.preloadScriptChunk('MoveMruActions');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 2264));
});
exports.lazyAddFolderIdToMoveToMruList = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.addFolderIdToMoveToMruList; });
exports.lazyRemoveFolderIdFromMoveToMruList = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.removeFolderIdFromMoveToMruList; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1841:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getFolderMruConfigurationService_1 = __webpack_require__(1842);
var store_1 = __webpack_require__(1711);
var folderNameToId_1 = __webpack_require__(35);
var legacy_1 = __webpack_require__(1);
/**
 * Action to get Move to Mru list
 */
exports.default = legacy_1.action('getMoveToMruList')(function getMoveToMruList() {
    getFolderMruConfigurationService_1.default().then(function (response) { return processResponse(response); });
});
// Process TargetFolderMruConfiguration
function processResponse(response) {
    if (response.FolderMruEntries == null || response.FolderMruEntries.length == 0) {
        store_1.default.mruFolders.push(folderNameToId_1.default('inbox'));
        store_1.default.mruFolders.push(folderNameToId_1.default('deleteditems'));
        store_1.default.mruFolders.push(folderNameToId_1.default('archive'));
    }
    else {
        for (var i = 0; i < response.FolderMruEntries.length; i++) {
            var folderId = response.FolderMruEntries[i].EwsFolderIdEntry;
            store_1.default.mruFolders.push(folderId);
        }
    }
    store_1.default.isInitialized = true;
}
//# sourceMappingURL=getMoveToMruList.js.map

/***/ }),

/***/ 1842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getFolderMruConfigurationOperation_1 = __webpack_require__(1843);
/**
 * Action to get folder MRU Configuration
 * @return the TargetFolderMruConfiguration
 */
function getFolderMruConfigurationService() {
    return getFolderMruConfigurationOperation_1.default().then(function (response) {
        return response;
    });
}
exports.default = getFolderMruConfigurationService;
//# sourceMappingURL=getFolderMruConfigurationService.js.map

/***/ }),

/***/ 1843:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
function getFolderMruConfigurationOperation(options) {
    return ServiceRequest_1.makeServiceRequest("GetFolderMruConfiguration", {}, options);
}
exports.default = getFolderMruConfigurationOperation;


/***/ }),

/***/ 2148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var deleteItemRequest_1 = __webpack_require__(2149);
var itemId_1 = __webpack_require__(94);
var deleteItemOperation_1 = __webpack_require__(2150);
var ServiceRequestUtils_1 = __webpack_require__(31);
function createItemIdForRequest(itemIdType) {
    return itemId_1.default({
        Id: itemIdType.Id,
        ChangeKey: itemIdType.ChangeKey,
    });
}
function configureRequestBody(itemIds, disposalType) {
    return deleteItemRequest_1.default({
        ItemIds: itemIds.map(function (itemId) { return createItemIdForRequest(itemId); }),
        DeleteType: disposalType,
        SuppressReadReceipts: true,
        ReturnMovedItemIds: true,
        SendMeetingCancellations: 'SendToNone',
        AffectedTaskOccurrences: 'AllOccurrences',
    });
}
function deleteItemService(itemIds, disposalType, requestInitOptions) {
    var requestBody = configureRequestBody(itemIds, disposalType);
    return deleteItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }, requestInitOptions).then(function (response) {
        return response.Body.ResponseMessages.Items;
    });
}
exports.default = deleteItemService;
//# sourceMappingURL=deleteItemService.js.map

/***/ }),

/***/ 2149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function deleteItemRequest(data) {
    var result = tslib_1.__assign({ __type: 'DeleteItemRequest:#Exchange' }, data);
    return result;
}
exports.default = deleteItemRequest;


/***/ }),

/***/ 2150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var deleteItemJsonRequest_1 = __webpack_require__(2151);
function deleteItemOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = deleteItemJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("DeleteItem", req, options);
}
exports.default = deleteItemOperation;


/***/ }),

/***/ 2151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function deleteItemJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'DeleteItemJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = deleteItemJsonRequest;


/***/ }),

/***/ 2226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(17);
var legacy_1 = __webpack_require__(1);
exports.folderTableSelector = {
    folderTable: function () { return Store_1.default.folders.folderTable; },
};
/** Returns true if a folder is specified distinguished folder. */
function isDistinguishedFolder(folder, distinguishedFolderId) {
    // folder is null in search scenario
    return !!folder && folder.distinguishedFolderId == distinguishedFolderId;
}
exports.isDistinguishedFolder = isDistinguishedFolder;
/** Returns true if a folder is a subfolder of a specified distinguished folder. */
function isSubFolderOfDistinguishedFolder(folder, distinguishedFolderId, state) {
    // folder is null in search scenario
    var parentFolderId = !!folder && folder.ParentFolderId;
    if (!parentFolderId) {
        // The parentFolderId is null for msgfolderroot, which means it's not a subfolder
        return false;
    }
    var parentFolder = state.folderTable.get(parentFolderId.Id);
    while (parentFolder) {
        if (parentFolder.distinguishedFolderId == distinguishedFolderId) {
            return true;
        }
        else if (!parentFolder.ParentFolderId) {
            return false;
        }
        parentFolder = state.folderTable.get(parentFolder.ParentFolderId.Id);
    }
    return false;
}
exports.isSubFolderOfDistinguishedFolder = isSubFolderOfDistinguishedFolder;
exports.isUnderDistinguishedFolder = legacy_1.select({
    folderTable: function () { return Store_1.default.folders.folderTable; },
})(isSubFolderOfDistinguishedFolder);
/** Returns true if a folder is a specified distinguished folder or is a subfolder of it.*/
exports.default = legacy_1.select({
    folderTable: function () { return Store_1.default.folders.folderTable; },
})(function isFolderOrSubFolderOfDistinguishedFolder(folder, distinguishedFolderId, state) {
    return (isDistinguishedFolder(folder, distinguishedFolderId) ||
        exports.isUnderDistinguishedFolder(folder, distinguishedFolderId, state));
});
//# sourceMappingURL=isFolderOrSubFolderOfDistinguishedFolder.js.map

/***/ }),

/***/ 2574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var deleteMailListRows_1 = __webpack_require__(3467);
exports.deleteMailListRows = deleteMailListRows_1.default;
var deleteItems_1 = __webpack_require__(3192);
exports.deleteItemFromReadingPane = deleteItems_1.deleteItemFromReadingPane;
var toggleRowsFlagState_1 = __webpack_require__(5586);
exports.toggleRowsFlagState = toggleRowsFlagState_1.default;
var setMailListRowsFlagState_1 = __webpack_require__(3816);
exports.setMailListRowsFlagState = setMailListRowsFlagState_1.default;
var setItemsFlagState_1 = __webpack_require__(3817);
exports.setItemsFlagStateFromReadingPane = setItemsFlagState_1.setItemsFlagStateFromReadingPane;
var moveMailListRows_1 = __webpack_require__(3819);
exports.moveMailListRows = moveMailListRows_1.default;
var archiveMailListRows_1 = __webpack_require__(5606);
exports.archiveMailListRowsFromTable = archiveMailListRows_1.default;
var toggleRowPinnedState_1 = __webpack_require__(5607);
exports.toggleRowPinnedState = toggleRowPinnedState_1.default;
var markRowsPinnedUnpinned_1 = __webpack_require__(5609);
exports.markRowsPinnedUnpinned = markRowsPinnedUnpinned_1.default;
var markRowsAsPhishingFromTable_1 = __webpack_require__(5610);
exports.markRowsAsPhishingFromTable = markRowsAsPhishingFromTable_1.default;
var markItemAsPhishingFromReadingPane_1 = __webpack_require__(5615);
exports.markItemAsPhishingFromReadingPane = markItemAsPhishingFromReadingPane_1.default;
var restoreConversation_1 = __webpack_require__(5616);
exports.restoreConversations = restoreConversation_1.default;
var moveMailListRowsToFocusedOrOther_1 = __webpack_require__(3826);
exports.moveMailListRowsToFocusedOrOther = moveMailListRowsToFocusedOrOther_1.default;
var alwaysMoveRowToFocusedOrOther_1 = __webpack_require__(5628);
exports.alwaysMoveRowToFocusedOrOther = alwaysMoveRowToFocusedOrOther_1.default;
var unsubscribeEmail_1 = __webpack_require__(5634);
exports.unsubscribeEmail = unsubscribeEmail_1.default;
var clientOptOut_1 = __webpack_require__(5635);
exports.clientOptOut = clientOptOut_1.default;
var sweepConversations_1 = __webpack_require__(5642);
exports.sweepConversations = sweepConversations_1.default;
var emptyFolder_1 = __webpack_require__(3835);
exports.emptyFolder = emptyFolder_1.default;
var emptySearchTableView_1 = __webpack_require__(5652);
exports.emptySearchTableView = emptySearchTableView_1.default;
var emptyTableView_1 = __webpack_require__(5653);
exports.emptyTableView = emptyTableView_1.default;
var markRowsJunkNotJunkFromTable_1 = __webpack_require__(5654);
exports.markRowsJunkNotJunkFromTable = markRowsJunkNotJunkFromTable_1.default;
var markItemJunkNotJunkFromReadingPane_1 = __webpack_require__(5661);
exports.markItemJunkNotJunkFromReadingPane = markItemJunkNotJunkFromReadingPane_1.default;
var blockLastSendersFromTable_1 = __webpack_require__(5662);
exports.blockLastSendersFromTable = blockLastSendersFromTable_1.default;
var blockLastSenderFromReadingPane_1 = __webpack_require__(5665);
exports.blockLastSenderFromReadingPane = blockLastSenderFromReadingPane_1.default;
var categoryTriageActions_1 = __webpack_require__(5666);
exports.addCategoriesFromTable = categoryTriageActions_1.addCategoriesFromTable;
exports.removeCategoriesFromTable = categoryTriageActions_1.removeCategoriesFromTable;
exports.clearCategoriesFromTable = categoryTriageActions_1.clearCategoriesFromTable;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2625:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_analytics_1 = __webpack_require__(12);
var folderIdToName_1 = __webpack_require__(48);
var owa_mail_list_store_1 = __webpack_require__(5);
function getSortColumnToLog(tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var sortColumn = null;
    if (tableView) {
        var isSortBySupported = tableView.tableQuery.type == 0 /* Folder */ ||
            tableView.tableQuery.type == 2 /* Group */;
        sortColumn = isSortBySupported ? owa_mail_list_store_1.getSortByForTable(tableView).sortColumn : null;
    }
    return sortColumn;
}
exports.default = {
    blockSendersFromTableDatapoint: {
        datapoint: {
            name: 'TnS_BlockSendersFromListView',
            customData: function (rowKeys, tableView, actionSource) { return [actionSource, rowKeys.length, tableView.tableQuery.type]; },
        },
    },
    blockSenderFromReadingPaneDatapoint: {
        datapoint: {
            name: 'TnS_BlockSenderFromReadingPane',
        },
    },
    setConversationsFlagStateDatapoint: { datapoint: { name: 'TnS_FlagConversation' } },
    setItemsFlagStateDatapoint: { datapoint: { name: 'TnS_FlagItems' } },
    archiveMailListRowsDatapoint: {
        datapoint: {
            name: 'TnS_ArchiveMailListRows',
            customData: function (rowKeys, tableView, actionSource) { return [
                actionSource,
                rowKeys.length,
                tableView.tableQuery.type,
                tableView.tableQuery.listViewType,
            ]; },
        },
    },
    deleteConversationDatapoint: {
        datapoint: {
            name: 'TnS_DeleteConversation',
            options: { isQos: true },
            customData: function (conversationActionContexts, originalTableViewId, disposalType, instrumentationContexts, actionSource) { return [
                actionSource,
                conversationActionContexts.length,
                disposalType,
                getSortColumnToLog(originalTableViewId),
            ]; },
        },
    },
    deleteItemsDatapoint: {
        datapoint: {
            name: 'TnS_DeleteItem',
            options: { isQos: true },
            customData: function (itemIds, disposalType, parentFolderId, actionSource, requestInitOptions) { return [actionSource, itemIds.length, disposalType]; },
        },
    },
    deleteItemsFromTableDatapoint: {
        datapoint: {
            name: 'TnS_DeleteItemsFromTable',
            customData: function (itemRowKeys, tableViewId, actionSource) { return [actionSource, itemRowKeys.length, getSortColumnToLog(tableViewId)]; },
        },
    },
    markItemsJunkNotJunkDatapoint: {
        datapoint: {
            name: 'TnS_JunkItem',
            customData: function (itemIds, isJunkValueToSet, actionSource) { return [actionSource, itemIds.length, isJunkValueToSet]; },
        },
    },
    markItemsAsPhishingDatapoint: {
        datapoint: {
            name: 'TnS_PhishItem',
            customData: function (itemIds, parentFolderId, actionSource) { return [actionSource, itemIds.length]; },
        },
    },
    moveConversationDatapoint: {
        datapoint: {
            name: 'TnS_MoveConversation',
            customData: function (rowKeys, destinationFolderId, originalTableView, actionSource) { return [
                actionSource,
                originalTableView.tableQuery.type,
                originalTableView.tableQuery.folderId // folderId is null in search
                    ? folderIdToName_1.default(originalTableView.tableQuery.folderId)
                    : null,
                folderIdToName_1.default(destinationFolderId),
                rowKeys.length,
            ]; },
            options: function (rowKeys, destinationFolderId, originalTableView, actionSource) {
                return {
                    variant: actionSource == 'NonUserAction'
                        ? owa_analytics_1.DatapointVariant.None // Do not log the datapoint if it's not user triggered
                        : owa_analytics_1.DatapointVariant.Both,
                };
            },
        },
    },
    moveItemsDatapoint: {
        datapoint: {
            name: 'TnS_MoveItem',
            customData: function (rowKeys, destinationFolderId, originalTableView, actionSource) { return [
                actionSource,
                originalTableView.tableQuery.type,
                originalTableView.tableQuery.folderId // folderId is null in search
                    ? folderIdToName_1.default(originalTableView.tableQuery.folderId)
                    : null,
                folderIdToName_1.default(destinationFolderId),
                rowKeys.length,
            ]; },
            options: function (rowKeys, destinationFolderId, originalTableView, actionSource) {
                return {
                    variant: actionSource == 'NonUserAction'
                        ? owa_analytics_1.DatapointVariant.None // Do not log the datapoint if it's not user triggered
                        : owa_analytics_1.DatapointVariant.Both,
                };
            },
        },
    },
    restoreConversationDatapoint: { datapoint: { name: 'TnS_RestoreConversation' } },
    unsubscribeDatapoint: {
        datapoint: {
            name: 'TnS_Unsubscribe',
            customData: function (message, originalTableView, isTrustedUnsubscribe, actionSource) { return [actionSource, isTrustedUnsubscribe]; },
        },
    },
    emptyFolderDatapoint: { datapoint: { name: 'TnS_EmptyFolder' } },
    optOutDatapoint: { datapoint: { name: 'TnS_OptOut' } },
    pinConversationsDatapoint: {
        datapoint: {
            name: 'TnS_PinConversations',
            customData: function (conversationRowKeys, tableView, shouldMarkAsPinned, actionSource) { return [actionSource, shouldMarkAsPinned, conversationRowKeys.length]; },
        },
    },
    pinItemsDatapoint: {
        datapoint: {
            name: 'TnS_PinItems',
            customData: function (rowKeys, tableView, shouldMarkAsPinned, actionSource) { return [actionSource, shouldMarkAsPinned, rowKeys.length]; },
        },
    },
    moveConversationToFocusedOrOther: {
        datapoint: {
            name: 'TnS_MoveConversationToFocusedOrOther',
            customData: function (conversationRowKeys, tableViewId, actionSource) { return [
                actionSource,
                conversationRowKeys.length,
                owa_mail_list_store_1.getFocusedFilterForTable(owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId)),
            ]; },
        },
    },
    alwaysMoveRowToFocusedOrOtherDatapoint: {
        datapoint: {
            name: 'TnS_AlwaysMoveRowToFocusedOrOther',
            customData: function (rowKeys, tableView, actionSource) { return [actionSource, owa_mail_list_store_1.getFocusedFilterForTable(tableView)]; },
        },
    },
    addCategories: {
        datapoint: {
            name: 'Triage_AddCategories',
            customData: function (rowKeys, tableViewId, categoriesToAdd, actionSource) { return [actionSource, rowKeys.length]; },
        },
    },
    removeCategories: {
        datapoint: {
            name: 'Triage_RemoveCategories',
            customData: function (rowKeys, tableViewId, categoriesToRemove, actionSource) { return [actionSource, rowKeys.length]; },
        },
    },
    clearCategories: {
        datapoint: {
            name: 'Triage_ClearCategories',
            customData: function (rowKeys, tableViewId, actionSource) { return [actionSource, rowKeys.length]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map

/***/ }),

/***/ 2930:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var browserCookieWrapper_1 = __webpack_require__(3021);
var getUserConfiguration_1 = __webpack_require__(9);
exports.OPT_IN_COOKIE_NAME = 'OptInPrg';
function isClientOptingReact() {
    return isClientOpting(2 /* React */);
}
exports.isClientOptingReact = isClientOptingReact;
function isClientOptingJsmvvm() {
    return isClientOpting(1 /* Jsmvvm */);
}
exports.isClientOptingJsmvvm = isClientOptingJsmvvm;
function isClientOpting(client) {
    var optinCookieValue = browserCookieWrapper_1.getCookie(exports.OPT_IN_COOKIE_NAME);
    return optinCookieValue == '' + client;
}
function optIntoJsmvvmClient() {
    updateClientOptInStateCookie(1 /* Jsmvvm */);
}
exports.optIntoJsmvvmClient = optIntoJsmvvmClient;
function optIntoJsmvvmClientAndRedirect(modulePath) {
    optIntoJsmvvmClient();
    var sessionType = getUserConfiguration_1.default().SessionSettings.WebSessionType;
    var redirectPath = '/owa/';
    var params = [];
    if (sessionType) {
        params.push('isc=' + sessionType);
    }
    if (modulePath) {
        params.push(modulePath);
    }
    if (params.length > 0) {
        redirectPath = redirectPath + '?' + params.join('&');
    }
    location.assign(redirectPath);
}
exports.optIntoJsmvvmClientAndRedirect = optIntoJsmvvmClientAndRedirect;
function updateClientOptInStateCookie(value) {
    if (value == null) {
        browserCookieWrapper_1.updateCookie(exports.OPT_IN_COOKIE_NAME);
    }
    else {
        browserCookieWrapper_1.updateCookie(exports.OPT_IN_COOKIE_NAME, '' + value, { path: '/' });
    }
}
exports.updateClientOptInStateCookie = updateClientOptInStateCookie;
//# sourceMappingURL=mailOptinUtility.js.map

/***/ }),

/***/ 3021:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BrowserCookies = __webpack_require__(378);
function getCookie(key) {
    return BrowserCookies.get(key);
}
exports.getCookie = getCookie;
function updateCookie(key, value, options) {
    if (value) {
        BrowserCookies.set(key, value, options);
    }
    else {
        BrowserCookies.remove(key);
    }
}
exports.updateCookie = updateCookie;
//# sourceMappingURL=browserCookieWrapper.js.map

/***/ }),

/***/ 3114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_mail_store_1 = __webpack_require__(38);
/**
 * Create the item contexts for triage actions that need delete store update
 * @param itemIds of the items that need to be updated in store
 * @returns the item contexts to be used to update the store
 */
function createItemContextsForDeleteStoreUpdate(itemIds) {
    var itemContexts = itemIds.map(function (itemIdValue) {
        var item = owa_mail_store_1.mailStore.items.get(itemIdValue);
        var isReadValue;
        if (owa_mail_list_store_1.isItemOfMessageType(item)) {
            isReadValue = item.IsRead;
        }
        else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
            isRead: isReadValue,
        };
    });
    return itemContexts;
}
exports.default = createItemContextsForDeleteStoreUpdate;
//# sourceMappingURL=createItemContextsForDeleteStoreUpdate.js.map

/***/ }),

/***/ 3147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Maximum number of items to display as part of a header for confirmation dialogs,
 * i.e. "Delete 10,000 items". If the number is greater than this value, then we'll
 * show the "VALUE+" instead.
 */
exports.MAX_LABEL_ITEM_COUNT = 10000;
/**
 * The threshold required to show a confirmation dialog. If the number
 * of selected items is lower than this value, we won't show a confirmation
 * dialog for whatever action is being performed.
 */
exports.NUMBER_OF_SELECTED_ITEMS_THRESHOLD = 25;
//# sourceMappingURL=bulkTriageConstants.js.map

/***/ }),

/***/ 3169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(17);
var legacy_1 = __webpack_require__(1);
var isFolderOrSubFolderOfDistinguishedFolder_1 = __webpack_require__(2226);
exports.default = legacy_1.select({
    folderTable: function () { return Store_1.default.folders.folderTable; },
})(function isFolderUnderDeletedFolder(folder, state) {
    return isFolderOrSubFolderOfDistinguishedFolder_1.isUnderDistinguishedFolder(folder, 'deleteditems', state);
});
//# sourceMappingURL=isFolderUnderDeletedFolder.js.map

/***/ }),

/***/ 3192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var createItemContextsForDeleteStoreUpdate_1 = __webpack_require__(3114);
var deleteMailListRowsHelper_1 = __webpack_require__(3813);
var handleBlockActionForShadowMailbox_1 = __webpack_require__(3468);
var restoreItemService_1 = __webpack_require__(5581);
var owa_analytics_1 = __webpack_require__(12);
var owa_confirm_dialog_1 = __webpack_require__(223);
var deleteItemsStoreUpdate_1 = __webpack_require__(239);
var composeStore_1 = __webpack_require__(158);
var owa_mail_focus_manager_1 = __webpack_require__(208);
var owa_mail_list_store_1 = __webpack_require__(5);
var Store_1 = __webpack_require__(25);
var deleteItemService_1 = __webpack_require__(2148);
var Store_2 = __webpack_require__(17);
var undoActions = __webpack_require__(214);
var doesFolderIdEqualName_1 = __webpack_require__(682);
var owa_mail_strings_1 = __webpack_require__(22);
var legacy_1 = __webpack_require__(1);
var owa_mail_list_store_2 = __webpack_require__(5);
var owa_mail_actions_1 = __webpack_require__(238);
function isReplyingToOneOfItems(itemIds) {
    var replyItemId = composeStore_1.default.defaultViewState && composeStore_1.default.defaultViewState.itemId;
    return replyItemId && itemIds.indexOf(replyItemId.Id) >= 0;
}
/**
 * The action worker which handles deleting the given items
 * Note: This aciton is exported only for unit testing purposes
 * @param itemIds - the conversation that need to be deleted
 * @param originalTableView - the table view the conversation should be deleted from
 * @param disposalType - the disposal type
 * @param parentFolderId - the parent FolderId
 * @param actionSource - the action source
 */
exports.deleteItemsWithoutConfirmDialog = legacy_1.action('deleteItemsWithoutConfirmDialog', datapoints_1.default.deleteItemsDatapoint)(function deleteItemsWithoutConfirmDialog(itemIds, disposalType, parentFolderId, actionSource, instrumentationContexts, requestInitOptions) {
    var itemContexts = createItemContextsForDeleteStoreUpdate_1.default(itemIds);
    // Dispatch action to update the store state
    deleteItemsStoreUpdate_1.default(itemContexts, parentFolderId);
    undoActions.clearLastUndoableAction();
    // Make service request
    var serviceItemIds = itemIds.map(function (itemIdValue) {
        return {
            Id: itemIdValue,
        };
    });
    deleteItemService_1.default(serviceItemIds, disposalType, requestInitOptions).then(function (responseItems) {
        if (disposalType === 'MoveToDeletedItems') {
            addDeletedItemsToUndoStack(responseItems);
        }
    });
    owa_mail_actions_1.userMailInteractionAction('Delete', instrumentationContexts);
});
exports.deleteItemFromReadingPane = legacy_1.action('deleteItemFromReadingPane')(legacy_1.select({
    item: function (itemId) { return Store_2.default.items.get(itemId.Id); },
})(function deleteItemFromReadingPane(itemId, disposalType, actionSource, instrumentationContexts, state) {
    // Early return if the action is blocked for shadow mailbox
    var sourceFolderId = state.item.ParentFolderId.Id;
    if (handleBlockActionForShadowMailbox_1.default(sourceFolderId, null)) {
        return;
    }
    var tableView = owa_mail_list_store_2.getSelectedTableView();
    var requestInitOptions = owa_mail_list_store_2.getMailboxInfo(tableView).requestOptions;
    var shouldUserConfirmDeletion = (disposalType == 'SoftDelete' &&
        doesFolderIdEqualName_1.default(state.item.ParentFolderId.Id, 'deleteditems')) ||
        (tableView && tableView.tableQuery.type == 2 /* Group */);
    owa_confirm_dialog_1.confirm('', owa_mail_strings_1.default.confirmDeletingItem, !shouldUserConfirmDeletion /*resolveImmediately*/, {
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then(function (response) {
        if (response == 0 /* ok */) {
            exports.deleteItemsWithoutConfirmDialog([itemId.Id], disposalType, sourceFolderId, actionSource, instrumentationContexts, requestInitOptions);
            owa_mail_focus_manager_1.resetFocus();
        }
    });
}));
/**
 * Initiates deleting of selected items
 * @param itemRowKeys - row keys to be deleted
 * @param originalTableViewId - the table view the conversation should be deleted from
 * @param isExplicitSoftDelete flag to indicate whether disposal type is soft delete
 * @param actionSource - the action source
 * @param state - some additional state required to complete the action
 */
exports.deleteItemsFromTable = legacy_1.select({
    originalTableView: function (conversationId, originalTableViewId) {
        return Store_1.default.tableViews.get(originalTableViewId);
    },
})(function deleteItemsFromTable(itemRowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource, state) {
    var confirmDialogStrings = {
        deleteNumberOfRows: owa_mail_strings_1.default.deleteNumberOfItems,
        confirmDeleteRows: owa_mail_strings_1.default.confirmDeletingItems,
    };
    owa_analytics_1.logUsage(datapoints_1.default.deleteItemsFromTableDatapoint.datapoint.name, datapoints_1.default.deleteItemsFromTableDatapoint.datapoint.customData(itemRowKeys, originalTableViewId, actionSource));
    return deleteMailListRowsHelper_1.default(itemRowKeys, originalTableViewId, isExplicitSoftDelete, function (rowKeys, disposalType) {
        var rowIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, originalTableViewId);
        exports.deleteItemsWithoutConfirmDialog(rowIdStrings, disposalType, state.originalTableView.tableQuery.folderId, actionSource, instrumentationContexts);
    }, isReplyingToOneOfItems, confirmDialogStrings);
});
function addDeletedItemsToUndoStack(responseItems) {
    var movedItemIds = [];
    for (var _i = 0, responseItems_1 = responseItems; _i < responseItems_1.length; _i++) {
        var responseItem = responseItems_1[_i];
        var deleteItemResponse = responseItem;
        if (deleteItemResponse.ResponseClass == 'Success') {
            movedItemIds.push(deleteItemResponse.MovedItemId.Id);
        }
    }
    if (movedItemIds.length > 0) {
        undoActions.addActionToUndoStack(function () {
            return restoreItemService_1.default(movedItemIds);
        });
    }
}
//# sourceMappingURL=deleteItems.js.map

/***/ }),

/***/ 3193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var itemId_1 = __webpack_require__(94);
/**
 * Get the ItemIds in the specified conversations
 * @param itemIdsToUpdate an array of item id strings
 * @return an array of ItemIds for EWS service request
 */
function getServiceItemIds(itemIdsToUpdate) {
    var itemIds = itemIdsToUpdate.map(function (id) { return itemId_1.default({ Id: id }); });
    return itemIds;
}
exports.default = getServiceItemIds;
//# sourceMappingURL=getServiceItemIds.js.map

/***/ }),

/***/ 3194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getTableConversationRelation_1 = __webpack_require__(34);
/**
 * Get all item ids in the conversations
 * @param conversationIds an array of conversation itemIds
 * @param tableViewId the table view id
 * @return an array of all item id strings in the specified conversations
 */
function getItemIdsFromConversations(rowKeys, tableViewId) {
    var allItemIds = {};
    rowKeys.forEach(function (rowKey) {
        var itemIds = getTableConversationRelation_1.default(rowKey, tableViewId).itemIds;
        itemIds.forEach(function (id) {
            // In case of multi-value sorts there can be two rows with same conversation
            // Hence we have to dedup the ids
            if (!allItemIds[id]) {
                allItemIds[id] = true;
            }
        });
    });
    return Object.keys(allItemIds);
}
exports.default = getItemIdsFromConversations;
//# sourceMappingURL=getItemIdsFromConversations.js.map

/***/ }),

/***/ 3285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isSharedFolder(folderId) {
    /* TODO: 1604 add sharedFolders into react */
    return false;
}
exports.default = isSharedFolder;
//# sourceMappingURL=isSharedFolder.js.map

/***/ }),

/***/ 3467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(25);
var deleteConversations_1 = __webpack_require__(3812);
var deleteItems_1 = __webpack_require__(3192);
var getInstrumentationContextsFromTableView_1 = __webpack_require__(215);
function deleteMailListRows(rowKeys, originalTableViewId, isExplicitSoftDelete, actionSource) {
    var tableView = Store_1.default.tableViews.get(originalTableViewId);
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            deleteConversations_1.deleteConversationsFromTable(rowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource);
            break;
        case 1 /* Message */:
            deleteItems_1.deleteItemsFromTable(rowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource);
            break;
    }
}
exports.default = deleteMailListRows;
//# sourceMappingURL=deleteMailListRows.js.map

/***/ }),

/***/ 3468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_confirm_dialog_1 = __webpack_require__(223);
var Store_1 = __webpack_require__(17);
var getUserConfiguration_1 = __webpack_require__(9);
var owa_mail_strings_1 = __webpack_require__(22);
/**
 * Moving and deleting items to/from Starred and Important folders should be blocked. We will show following message prompt to the user if these actions are performed on the client -
 * - Move/Delete from Important: “You can’t move or delete items from this folder”
 * - Move/Delete to Important:" You can’t move items to this folder"
 * - Move/Delete from Starred: “To remove an item from this folder, unflag it”
 * - Move to Starred: “To move an item to this folder, flag it”
 * @param sourceFolderId - Source folder id
 * @param destinationFolderId - Destination folder id
 * @returns true if the action was blocked, false otherwise
 */
function handleBlockActionForShadowMailbox(sourceFolderId, destinationFolderId) {
    if (!getUserConfiguration_1.default().SessionSettings.IsShadowMailbox) {
        return false;
    }
    var message;
    var mailStore = Store_1.getStore();
    var sourceFolder = mailStore.folders.folderTable.get(sourceFolderId);
    var destinationFolder = mailStore.folders.folderTable.get(destinationFolderId);
    var sourceFolderType = sourceFolder.sourceWellKnownFolderType;
    if (sourceFolderType == 87 /* Important */) {
        message = owa_mail_strings_1.default.blockActionFromImportantFolder;
    }
    else if (sourceFolderType == 88 /* Starred */) {
        message = owa_mail_strings_1.default.blockMoveDeleteFromStarredFolder;
    }
    else if (destinationFolder != null) {
        var destinationFolderType = destinationFolder.sourceWellKnownFolderType;
        if (destinationFolderType == 87 /* Important */) {
            message = owa_mail_strings_1.default.blockActionToImportantFolder;
        }
        else if (destinationFolderType == 88 /* Starred */) {
            message = owa_mail_strings_1.default.blockMoveToStarredFolder;
        }
    }
    if (message != undefined) {
        owa_confirm_dialog_1.confirm('', message, false, {
            hideCancelButton: true,
        });
        return true;
    }
    return false;
}
exports.default = handleBlockActionForShadowMailbox;
//# sourceMappingURL=handleBlockActionForShadowMailbox.js.map

/***/ }),

/***/ 3469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_confirm_dialog_1 = __webpack_require__(223);
var undoActions = __webpack_require__(214);
var owa_mail_strings_1 = __webpack_require__(22);
/**
 * Helper method to trigger the confirm dialog before processing mark as phishing
 * @param markAsPhishingActionHandler callback after user confirms the mark as phishing action
 */
function confirmMarkAsPhishing(markAsPhishingActionHandler) {
    undoActions.clearLastUndoableAction();
    return owa_confirm_dialog_1.confirm(owa_mail_strings_1.default.phishingDialogTitle, owa_mail_strings_1.default.phishingSubText, false /* resolveImmediately */, {
        okText: owa_mail_strings_1.default.reportPhishing,
        cancelText: owa_mail_strings_1.default.dontReportPhishing,
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then(function (response) {
        if (response === 0 /* ok */) {
            markAsPhishingActionHandler();
        }
    });
}
exports.default = confirmMarkAsPhishing;
//# sourceMappingURL=confirmMarkAsPhishing.js.map

/***/ }),

/***/ 3470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var reportMessageToSafetyLibraryService_1 = __webpack_require__(3825);
var legacy_1 = __webpack_require__(1);
/**
 * The action which marks items as phishing.
 * @param itemIds - the itemIds to mark as phishing * @param actionSource - where this mark as phishing action is triggered
 * @param markAsPhishingStoreUpdate the callback function to update the store upon markItemsAsPhishingDatapoint as phishing
 * @returns a promise to end the markItemsAsPhishingDatapoint datapoint
 */
exports.default = legacy_1.action('markItemsAsPhishing', datapoints_1.default.markItemsAsPhishingDatapoint)(function markItemsAsPhishingBasedOnItemIds(itemIds, actionSource, markAsPhishingStoreUpdate) {
    try {
        reportMessageToSafetyLibraryService_1.default(itemIds, 3 /* Phish */);
    }
    catch (error) {
        // VSO 19006: Handle service error caused by block
    }
    markAsPhishingStoreUpdate();
    // Synchronously returns the promise to end the markItemsAsPhishingDatapoint datapoint
    return Promise.resolve();
});
//# sourceMappingURL=markItemsAsPhishingBasedOnItemIds.js.map

/***/ }),

/***/ 3472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var markAsJunkService_1 = __webpack_require__(5656);
var undoActions = __webpack_require__(214);
var legacy_1 = __webpack_require__(1);
var owa_mail_actions_1 = __webpack_require__(238);
/**
 * mark item as junk action
 * @param itemIds of the items to be marked as junk/not junk
 * @param isJunkValueToSet used to determine whether the item should be marked as junk
 * @param actionSource the action source where this action is triggered
 */
exports.default = legacy_1.action('markItemsJunkNotJunkBasedOnItemIds', datapoints_1.default.markItemsJunkNotJunkDatapoint)(function markItemsJunkNotJunkBasedOnItemIds(itemIds, isJunkValueToSet, actionSource, instrumentationContexts, markItemsJunkNotJunkStoreUpdate) {
    undoActions.clearLastUndoableAction();
    markAsJunkService_1.default(itemIds, isJunkValueToSet);
    markItemsJunkNotJunkStoreUpdate();
    if (isJunkValueToSet) {
        owa_mail_actions_1.userMailInteractionAction('MarkAsJunk', instrumentationContexts);
    }
});
//# sourceMappingURL=markItemsJunkNotJunkBasedOnItemIds.js.map

/***/ }),

/***/ 3812:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var deleteMailListRowsHelper_1 = __webpack_require__(3813);
var deleteConversationService_1 = __webpack_require__(5580);
var restoreConversationService_1 = __webpack_require__(3814);
var composeStore_1 = __webpack_require__(158);
var getUniqueConversationContextsForRowKey_1 = __webpack_require__(3815);
var Store_1 = __webpack_require__(25);
var actionTypes_1 = __webpack_require__(74);
var undoActions = __webpack_require__(214);
var folderNameToId_1 = __webpack_require__(35);
var owa_mail_strings_1 = __webpack_require__(22);
var legacy_1 = __webpack_require__(1);
var stitch_1 = __webpack_require__(44);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_mail_actions_1 = __webpack_require__(238);
/**
 * The action worker which handles deleting the given conversations
 * @param conversationActionContexts - action contexts
 * @param conversationIds - the conversation that need to be deleted
 * @param originalTableView - the table view the conversation should be deleted from
 * @param disposalType - the disposal type
 * @param actionSource - the action source
 */
exports.deleteConversationsWithoutConfirmDialog = legacy_1.action('deleteConversationsWithoutConfirmDialog', datapoints_1.default.deleteConversationDatapoint)(function deleteConversationsWithoutConfirmDialog(conversationActionContexts, originalTableViewId, disposalType, instrumentationContexts, actionSource) {
    var conversationIds = conversationActionContexts.map(function (conversationContext) { return conversationContext.conversationId; });
    var originalTableView = Store_1.default.tableViews.get(originalTableViewId);
    // raise stitch to delete conversation from list view and reading pane
    stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIds, originalTableView);
    undoActions.clearLastUndoableAction();
    var options = owa_mail_list_store_1.getMailboxInfo(originalTableView).requestOptions;
    var contextFolderId = owa_mail_list_store_1.getContextFolderIdForTable(originalTableView);
    // Make service request
    deleteConversationService_1.default(conversationActionContexts, contextFolderId, disposalType, options).then(function (response) {
        // After action completes successfully, add it to the undo stack
        // Only enable undo functionality when delete action was successful and if delete was not a SoftDelete
        if (response.ResponseClass == 'Success' && disposalType !== 'SoftDelete') {
            var deletedItemsFolderId_1 = folderNameToId_1.default('deleteditems');
            undoActions.addActionToUndoStack(function () {
                return restoreConversationService_1.default(conversationActionContexts, deletedItemsFolderId_1);
            });
        }
    });
    owa_mail_actions_1.userMailInteractionAction('Delete', instrumentationContexts);
});
/**
 * Initiates deleting of the given conversations
 * @param conversationRowKeys - the conversation that need to be deleted
 * @param originalTableViewId - the table view the conversation should be deleted from
 * @param isExplicitSoftDelete flag to indicate whether disposal type is soft delete
 * @param actionSource - the action source
 * @param state - some additional state required to complete the action
 */
exports.deleteConversationsFromTable = legacy_1.select({
    originalTableView: function (conversationId, originalTableViewId) {
        return Store_1.default.tableViews.get(originalTableViewId);
    },
})(function deleteConversationsFromTable(conversationRowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource, state) {
    var confirmDialogStrings = {
        deleteNumberOfRows: owa_mail_strings_1.default.deleteNumberOfConversations,
        confirmDeleteRows: owa_mail_strings_1.default.confirmDeletingConversation,
    };
    return deleteMailListRowsHelper_1.default(conversationRowKeys, originalTableViewId, isExplicitSoftDelete, function (rowKeys, disposalType) {
        var conversationActionContexts = getUniqueConversationContextsForRowKey_1.default(rowKeys, originalTableViewId);
        exports.deleteConversationsWithoutConfirmDialog(conversationActionContexts, originalTableViewId, disposalType, instrumentationContexts, actionSource);
    }, isReplyingToOneOfConversations, confirmDialogStrings);
});
function isReplyingToOneOfConversations(conversationIds) {
    var replyConversationId = composeStore_1.default.defaultViewState && composeStore_1.default.defaultViewState.conversationId;
    return replyConversationId && conversationIds.indexOf(replyConversationId) >= 0;
}
//# sourceMappingURL=deleteConversations.js.map

/***/ }),

/***/ 3813:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var composeStore_1 = __webpack_require__(158);
var folderNameToId_1 = __webpack_require__(35);
var handleBlockActionForShadowMailbox_1 = __webpack_require__(3468);
var isFolderUnderDeletedFolder_1 = __webpack_require__(3169);
var Store_1 = __webpack_require__(25);
var Store_2 = __webpack_require__(17);
var owa_mail_strings_1 = __webpack_require__(22);
var owa_confirm_dialog_1 = __webpack_require__(223);
var owa_strings_1 = __webpack_require__(20);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_mail_list_store_2 = __webpack_require__(5);
var owa_mail_compose_store_1 = __webpack_require__(114);
var owa_mail_search_store_1 = __webpack_require__(41);
var legacy_1 = __webpack_require__(1);
var bulkTriageConstants_1 = __webpack_require__(3147);
exports.default = legacy_1.select({
    originalTableView: function (conversationId, originalTableViewId) {
        return Store_1.default.tableViews.get(originalTableViewId);
    },
    folderTable: function () { return Store_2.default.folders.folderTable; },
    searchStore: function () { return owa_mail_search_store_1.searchStore; },
})(function deleteMailListRowsHelper(rowKeys, originalTableViewId, isExplicitSoftDelete, deleteRowsInternal, isReplyingToOneOfRows, confirmDialogStrings, state) {
    var originalTableView = state.originalTableView;
    var sourceFolderId = originalTableView.tableQuery.folderId;
    var areRowsUnderDeletedItems;
    var sourceFolderName;
    // Early return if the action is blocked for shadow mailbox
    if (handleBlockActionForShadowMailbox_1.default(sourceFolderId, null)) {
        return null;
    }
    var isSearchTable = originalTableView.tableQuery.type == 1 /* Search */;
    if (isSearchTable) {
        // OW:12312 [Refactor]handle batch conversation triage in search scenarios more elegantly
        // if we are searching in the Deleted Items folder, we want to permanently delete
        areRowsUnderDeletedItems =
            state.searchStore.staticFolderScopeId == folderNameToId_1.default('deleteditems');
        sourceFolderName = owa_mail_strings_1.default.searchFolderName; // "Search"
    }
    else {
        var sourceFolder = state.folderTable.get(sourceFolderId);
        areRowsUnderDeletedItems =
            sourceFolder.distinguishedFolderId === 'deleteditems' ||
                isFolderUnderDeletedFolder_1.default(sourceFolder);
        sourceFolderName = sourceFolder.DisplayName;
    }
    // Show confirm dialog for all group conversation deletions
    var isSoftDelete = isExplicitSoftDelete ||
        areRowsUnderDeletedItems ||
        originalTableView.tableQuery.type == 2 /* Group */;
    // Calculate whether we're above the selection count threshold in select all mode
    var selectionCountThresholdInSelectAll = rowKeys.length >= bulkTriageConstants_1.NUMBER_OF_SELECTED_ITEMS_THRESHOLD &&
        owa_mail_list_store_1.getIsEverythingSelectedInTable(originalTableView);
    /**
     * Determine title of confirmation dialog that'll be shown if we're above the
     * selection count threshold or if we're in a soft delete situation.
     */
    var title = rowKeys.length > 1
        ? owa_strings_1.format(confirmDialogStrings.deleteNumberOfRows, rowKeys.length)
        : owa_mail_strings_1.default.deleteItem;
    var subtext = isSoftDelete
        ? // "Do you want to permanently delete the selected items?"
            confirmDialogStrings.confirmDeleteRows
        : // "Are you sure you want to move all the selected items in [sourceFolderName] to Deleted Items?"
            owa_strings_1.format(owa_mail_strings_1.default.confirmEmptyFolderSubText, owa_mail_strings_1.default.allSelectedItems, sourceFolderName);
    var resolveImmediately = !isSoftDelete && !selectionCountThresholdInSelectAll;
    return owa_confirm_dialog_1.confirm(title, subtext, resolveImmediately /* resolveImmediately */, {
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then(function (response) {
        if (response === 0 /* ok */) {
            // Since row may have been deleted from the table while the confirm dialog was open,
            // we need to validate the row keys again before performing delete
            var filteredRowKeys = rowKeys.filter(function (rowKey) {
                var idx = originalTableView.rowKeys.indexOf(rowKey);
                return idx >= 0;
            });
            if (filteredRowKeys.length > 0) {
                deleteRowsIfNotReplying(filteredRowKeys, originalTableView, isSoftDelete ? 'SoftDelete' : 'MoveToDeletedItems', deleteRowsInternal, isReplyingToOneOfRows);
            }
        }
    });
});
/**
 * Proceeds to delete the given rows if user's not replying to one of the rows
 */
function deleteRowsIfNotReplying(rowKeys, originalTableView, disposalType, deleteRowsInternal, isReplyingToOneOfRows) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rowIdStrings, filteredRowKeys;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rowIdStrings = owa_mail_list_store_2.getRowIdsFromRowKeys(rowKeys, originalTableView.id);
                    if (!isReplyingToOneOfRows(rowIdStrings)) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_mail_compose_store_1.lazyDiscardCompose.importAndExecute(composeStore_1.default.defaultViewState)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    // Check isReplyingToOneOfRows for the second time to check the result of user's choice.
                    // If false, it means either
                    //    1. There's no compose for these rows at all, or
                    //    2. There was compose but user chose discard so compose was closed
                    // Then we can continue delete the rows
                    // If true, it means there is compose and user doesn't want to discard it. So we stop deleting now.
                    if (!isReplyingToOneOfRows(rowIdStrings)) {
                        filteredRowKeys = rowKeys.filter(function (rowKey) { return originalTableView.rowKeys.indexOf(rowKey) >= 0; });
                        if (filteredRowKeys.length > 0) {
                            deleteRowsInternal(rowKeys, disposalType);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=deleteMailListRowsHelper.js.map

/***/ }),

/***/ 3814:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getEwsRequestDateString_1 = __webpack_require__(693);
var getServiceContextFolderId_1 = __webpack_require__(697);
var applyConversationActionRequest_1 = __webpack_require__(685);
var conversationAction_1 = __webpack_require__(686);
var itemId_1 = __webpack_require__(94);
var applyConversationActionOperation_1 = __webpack_require__(687);
var Utils_1 = __webpack_require__(362);
/**
 * Create the restore conversation action used in request body
 * @param conversationContext the conversation context to be restored
 * @param folderId the folder id
 * @return the restore conversation action used in request body
 */
function createConversationAction(conversationContext, folderId) {
    return conversationAction_1.default({
        Action: 'Restore',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        ContextFolderId: getServiceContextFolderId_1.default(folderId),
        ConversationLastSyncTime: getEwsRequestDateString_1.default(conversationContext.conversationLastSyncTimeStamp),
    });
}
/**
 * Configure the request body
 * @param conversationContexts the conversation contexts to be deleted
 * @param folderId the folder id
 * @return the applyConversationActionRequest body
 */
function configureRequestBody(conversationContexts, folderId) {
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createConversationAction(conversationContext, folderId);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}
/**
 * Restore message service
 * @param conversationContexts the conversation contexts to be deleted
 * @param folderId the folder id
 * @return the ApplyConversationActionResponseMessage
 */
function restoreConversationService(conversationContexts, folderId) {
    var requestBody = configureRequestBody(conversationContexts, folderId);
    return applyConversationActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = restoreConversationService;
//# sourceMappingURL=restoreConversationService.js.map

/***/ }),

/***/ 3815:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_list_store_1 = __webpack_require__(5);
/**
 * Gets contextual information for ApplyConversationAction for a given conversation
 */
function getUniqueConversationContextsForRowKey(rowKeys, tableViewId) {
    var conversationActionContexts = [];
    var rowIds = {};
    rowKeys.forEach(function (rowKey) {
        var conversationContext = owa_mail_list_store_1.getApplyConversationActionContext(rowKey, tableViewId);
        // Do not add contexts for duplicate row Ids
        if (!rowIds[conversationContext.conversationId]) {
            rowIds[conversationContext.conversationId] = true;
            conversationActionContexts.push(conversationContext);
        }
    });
    return conversationActionContexts;
}
exports.default = getUniqueConversationContextsForRowKey;
//# sourceMappingURL=getUniqueConversationContextsForRowKey.js.map

/***/ }),

/***/ 3816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(25);
var setItemsFlagState_1 = __webpack_require__(3817);
var setConversationsFlagState_1 = __webpack_require__(5588);
var getInstrumentationContextsFromTableView_1 = __webpack_require__(215);
function setMailListRowsFlagState(rowKeys, tableViewId, flagStatusToApply) {
    var tableView = Store_1.default.tableViews.get(tableViewId);
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            setConversationsFlagState_1.default(rowKeys, instrumentationContexts, tableViewId, flagStatusToApply);
            break;
        case 1 /* Message */:
            setItemsFlagState_1.setItemsFlagStateFromTable(rowKeys, instrumentationContexts, tableViewId, flagStatusToApply);
            break;
    }
}
exports.default = setMailListRowsFlagState;
//# sourceMappingURL=setMailListRowsFlagState.js.map

/***/ }),

/***/ 3817:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var undoActions = __webpack_require__(214);
var datapoints_1 = __webpack_require__(2625);
var flagItemService_1 = __webpack_require__(5587);
var Store_1 = __webpack_require__(25);
var setRowsFlagStateHelper_1 = __webpack_require__(3818);
var owa_mail_strings_1 = __webpack_require__(22);
var legacy_1 = __webpack_require__(1);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_service_error_1 = __webpack_require__(152);
var owa_mail_actions_1 = __webpack_require__(238);
var owa_mail_store_1 = __webpack_require__(38);
var flagItemsStoreUpdate_1 = __webpack_require__(605);
var SetItemsFlagStateActionName = 'setItemsFlagState';
var setItemsFlagStateInternal = legacy_1.action(SetItemsFlagStateActionName, datapoints_1.default.setItemsFlagStateDatapoint)(function setItemsFlagStateInternal(itemIds, instrumentationContexts, flagStatusToApply, parentFolderId) {
    undoActions.clearLastUndoableAction();
    var itemContexts = itemIds.map(function (itemIdValue) {
        var item = owa_mail_store_1.selectMailStoreItemById(itemIdValue);
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
        };
    });
    owa_service_error_1.handleServiceError(SetItemsFlagStateActionName, flagStatusToApply == 'Flagged'
        ? owa_mail_strings_1.default.errorMarkingItemAsFlag
        : owa_mail_strings_1.default.errorMarkingItemAsUnFlag, function () {
        // Dispatch action to update the store state
        flagItemsStoreUpdate_1.default(itemContexts, flagStatusToApply, parentFolderId);
        var instrumentationFlag;
        switch (flagStatusToApply) {
            case 'Flagged':
                instrumentationFlag = 'Flag';
                break;
            case 'NotFlagged':
                instrumentationFlag = 'FlagCleared';
                break;
            case 'Complete':
                instrumentationFlag = 'FlagComplete';
                break;
        }
        owa_mail_actions_1.userMailInteractionAction(instrumentationFlag, instrumentationContexts);
        return flagItemService_1.default(itemIds, flagStatusToApply);
    });
});
/**
 * Set the specified flag state on a collection of items in listview table
 * @param itemRowKeys - the item row keys
 * @param tableViewId - the table view the conversations are in
 * @param flagType - the specified flag type to set
 */
function setItemsFlagStateFromTable(itemRowKeys, instrumentationContexts, tableViewId, flagStatusToApply) {
    var tableView = Store_1.default.tableViews.get(tableViewId);
    setRowsFlagStateHelper_1.default(itemRowKeys, tableViewId, flagStatusToApply, function (rowKeys, flagStatusToApply) {
        var rowIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, tableViewId);
        setItemsFlagStateInternal(rowIdStrings, instrumentationContexts, flagStatusToApply, tableView.tableQuery.folderId);
    });
}
exports.setItemsFlagStateFromTable = setItemsFlagStateFromTable;
function setItemsFlagStateFromReadingPane(itemIds, instrumentationContexts, flagStatusToApply, parentFolderId) {
    // Filter by existence in the item cache
    var filteredItemIds = itemIds.filter(function (itemId) { return !!owa_mail_store_1.selectMailStoreItemById(itemId); });
    if (filteredItemIds.length > 0) {
        setItemsFlagStateInternal(filteredItemIds, instrumentationContexts, flagStatusToApply, parentFolderId);
    }
}
exports.setItemsFlagStateFromReadingPane = setItemsFlagStateFromReadingPane;
//# sourceMappingURL=setItemsFlagState.js.map

/***/ }),

/***/ 3818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(25);
var owa_mail_list_store_1 = __webpack_require__(5);
function setRowsFlagStateHelper(itemRowKeys, tableViewId, flagStatusToApply, setRowsFlagStateInternal) {
    var tableView = Store_1.default.tableViews.get(tableViewId);
    // Filter out the rows which has the same flag type as the new flag type
    var filteredRowKeys = itemRowKeys.filter(function (rowKey) { return owa_mail_list_store_1.MailRowDataPropertyGetter.getFlagStatus(rowKey, tableView) != flagStatusToApply; });
    if (filteredRowKeys.length == 0) {
        // Nothing to set flag status on
        return;
    }
    setRowsFlagStateInternal(filteredRowKeys, flagStatusToApply);
}
exports.default = setRowsFlagStateHelper;
//# sourceMappingURL=setRowsFlagStateHelper.js.map

/***/ }),

/***/ 3819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moveConversations_1 = __webpack_require__(5592);
var moveItems_1 = __webpack_require__(5601);
var owa_mail_list_store_1 = __webpack_require__(5);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('moveMailListRows')(function moveMailListRows(rowKeys, destinationFolderId, originalTableViewId, actionSource) {
    var originalTableView = owa_mail_list_store_1.listViewStore.tableViews.get(originalTableViewId);
    switch (originalTableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            moveConversations_1.default(rowKeys, destinationFolderId, originalTableView, actionSource);
            break;
        case 1 /* Message */:
            moveItems_1.default(rowKeys, destinationFolderId, originalTableView, actionSource);
            break;
    }
});
//# sourceMappingURL=moveMailListRows.js.map

/***/ }),

/***/ 3820:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var undoActions = __webpack_require__(214);
var copyMailListRows_1 = __webpack_require__(5593);
var deleteMailListRows_1 = __webpack_require__(3467);
var getUserConfiguration_1 = __webpack_require__(9);
var handleBlockActionForShadowMailbox_1 = __webpack_require__(3468);
var Store_1 = __webpack_require__(17);
var getMoveKind_1 = __webpack_require__(5599);
var owa_mail_actions_1 = __webpack_require__(238);
var owa_mail_move_mru_1 = __webpack_require__(1840);
var owa_mail_list_store_1 = __webpack_require__(5);
var legacy_1 = __webpack_require__(1);
/**
 * Move rows from table action
 * @param rowKeys - the row keys of the rows that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
exports.default = legacy_1.select({
    sourceFolder: function (rowKeys, destinationFolderId, originalTableView) {
        return Store_1.default.folders.folderTable.get(originalTableView.tableQuery.folderId);
    },
    destinationFolder: function (rowKeys, destinationFolderId, originalTableView) { return Store_1.default.folders.folderTable.get(destinationFolderId); },
    isUserShadowMailbox: function () { return getUserConfiguration_1.default().SessionSettings.IsShadowMailbox; },
})(function moveMailListRowsHelper(rowKeys, destinationFolderId, originalTableView, moveRowsInternal, actionSource, state) {
    var sourceFolder = state.sourceFolder, destinationFolder = state.destinationFolder, isUserShadowMailbox = state.isUserShadowMailbox;
    var moveKind = getMoveKind_1.default(isUserShadowMailbox, sourceFolder, destinationFolder);
    var sourceFolderId = originalTableView.tableQuery.folderId;
    if (handleBlockActionForShadowMailbox_1.default(sourceFolderId, destinationFolderId)) {
        return;
    }
    undoActions.clearLastUndoableAction();
    // Since row may have been deleted because moveRows is an lazy action,
    // we need to validate the row keys again before performing move
    // Here we cannot compare destinationFolderId with sourceFolderId, because sourceFolderId is null in Search,
    // so we need to get the actual parentFolderId of each row
    var filteredRowKeys = rowKeys.filter(function (rowKey) {
        return originalTableView.rowKeys.indexOf(rowKey) >= 0 &&
            destinationFolderId !=
                owa_mail_list_store_1.MailRowDataPropertyGetter.getParentFolderId(rowKey, originalTableView);
    });
    var instrumentationContexts = [];
    var isSearch = originalTableView.tableQuery.type == 1 /* Search */;
    if (isSearch) {
        filteredRowKeys.forEach(function (rowKey) {
            var instrumentationContext = owa_mail_list_store_1.MailRowDataPropertyGetter.getInstrumentationContext(rowKey, originalTableView);
            if (instrumentationContext) {
                instrumentationContexts.push(instrumentationContext);
            }
        });
    }
    // We do not have any conversations that can be moved
    if (filteredRowKeys.length == 0) {
        return;
    }
    var promiseToReturn;
    switch (moveKind) {
        case 2 /* ShadowMailbox_Delete */:
            // if we are in a ShadowMailbox and actually need to perform a delete,
            // we call the deleteConversations action directly, which handles its own
            // service and undo operation
            return deleteMailListRows_1.default(filteredRowKeys, originalTableView.id, false);
        case 1 /* ShadowMailbox_Copy */:
            promiseToReturn = copyMailListRows_1.default(filteredRowKeys, originalTableView, destinationFolderId, sourceFolderId);
            break;
        case 0 /* Normal */:
        default:
            // Update Move to mru list
            owa_mail_move_mru_1.lazyAddFolderIdToMoveToMruList.importAndExecute(destinationFolderId);
            // Make service request
            // Task 658: Reload client state when move conversation fails on the server.
            promiseToReturn = moveRowsInternal(filteredRowKeys, destinationFolderId, originalTableView, sourceFolderId);
            break;
    }
    owa_mail_actions_1.userMailInteractionAction('Move', instrumentationContexts);
    return promiseToReturn;
});
//# sourceMappingURL=moveMailListRowsHelper.js.map

/***/ }),

/***/ 3821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var markItemsAsPinnedService_1 = __webpack_require__(3822);
var owa_mail_list_actions_1 = __webpack_require__(80);
var filterConversationRowsByRestriction_1 = __webpack_require__(710);
var getTableConversationRelation_1 = __webpack_require__(34);
var pinningUtils_1 = __webpack_require__(229);
var actionTypes_1 = __webpack_require__(74);
var undoActions = __webpack_require__(214);
var legacy_1 = __webpack_require__(1);
var stitch_1 = __webpack_require__(44);
var owa_mail_list_store_1 = __webpack_require__(5);
function getItemIdsToUpdate(rowKeys, tableViewId, shouldMarkAsPinned) {
    var itemIdsToUpdate = {};
    for (var i = 0; i < rowKeys.length; i++) {
        var tableConversationRelation = getTableConversationRelation_1.default(rowKeys[i], tableViewId);
        if (shouldMarkAsPinned) {
            // If pinning, pin the last item in each conversation. The last delivered item is first in the list of ItemIds
            var itemId = tableConversationRelation.itemIds[0];
            if (!itemIdsToUpdate[itemId]) {
                itemIdsToUpdate[itemId] = true;
            }
        }
        else {
            // If unpinning, unpin all local items in conversation.
            tableConversationRelation.itemIds.forEach(function (itemId) {
                if (!itemIdsToUpdate[itemId]) {
                    itemIdsToUpdate[itemId] = true;
                }
            });
        }
    }
    return Object.keys(itemIdsToUpdate);
}
function shouldPerformPinUnpinAction(tableConversationRelation, pin) {
    return tableConversationRelation && pinningUtils_1.getIsConversationPinned(tableConversationRelation) != pin;
}
exports.default = legacy_1.action('pinConversations', datapoints_1.default.pinConversationsDatapoint)(function pinConversations(conversationRowKeys, tableView, shouldMarkAsPinned, actionSource) {
    undoActions.clearLastUndoableAction();
    var filteredRowKeys = filterConversationRowsByRestriction_1.default(conversationRowKeys, tableView.id, shouldPerformPinUnpinAction, shouldMarkAsPinned);
    var conversationIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    var itemIdsToUpdate = getItemIdsToUpdate(filteredRowKeys, tableView.id, shouldMarkAsPinned);
    if (itemIdsToUpdate.length == 0) {
        // No need to send out the service call
        return Promise.resolve();
    }
    stitch_1.raiseAction(actionTypes_1.actionNames.MarkConversationsAsPinned)(conversationIdStrings, tableView.id, shouldMarkAsPinned);
    // Treat this pinning operation as a row move operation
    owa_mail_list_actions_1.setRowOperation(tableView, 2 /* RowMove */);
    // Make service request
    // Task 658: Reload client state when pin action fails on the server
    markItemsAsPinnedService_1.default(itemIdsToUpdate, shouldMarkAsPinned);
    // return the promise to catch the end to end time of pinConversationDatapoint
    return Promise.resolve();
});
//# sourceMappingURL=pinConversations.js.map

/***/ }),

/***/ 3822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateItemRequest_1 = __webpack_require__(635);
var deleteItemField_1 = __webpack_require__(5608);
var propertyUri_1 = __webpack_require__(40);
var itemId_1 = __webpack_require__(94);
var itemChange_1 = __webpack_require__(637);
// Import functions
var ServiceRequestUtils_1 = __webpack_require__(31);
var updateItemOperation_1 = __webpack_require__(636);
var createSetItemField_1 = __webpack_require__(639);
// Import utils
var pinningUtils_1 = __webpack_require__(229);
function createRequestBody(itemIdsToUpdate, shouldMarkAsPinned) {
    var itemChanges = [];
    for (var _i = 0, itemIdsToUpdate_1 = itemIdsToUpdate; _i < itemIdsToUpdate_1.length; _i++) {
        var messageItemId = itemIdsToUpdate_1[_i];
        var update = void 0;
        var propertyName = 'RenewTime';
        if (shouldMarkAsPinned) {
            // Set renew time to pin time
            update = createSetItemField_1.default(propertyName, pinningUtils_1.utcPinnedEwsTimeStamp);
        }
        else {
            // Remove renew time property
            update = deleteItemField_1.default({
                Path: propertyUri_1.default({ FieldURI: propertyName }),
            });
        }
        var singleItemChange = itemChange_1.default({
            Updates: [update],
            ItemId: itemId_1.default({
                Id: messageItemId,
            }),
        });
        itemChanges.push(singleItemChange);
    }
    return updateItemRequest_1.default({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}
function markItemsAsPinnedService(itemIdsToUpdate, shouldMarkAsPinned) {
    var requestBody = createRequestBody(itemIdsToUpdate, shouldMarkAsPinned);
    // We want to always set the pin time in UTC time, so it's invariant to user time zone
    var jsonRequestHeader = ServiceRequestUtils_1.getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';
    return updateItemOperation_1.default({
        Header: jsonRequestHeader,
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = markItemsAsPinnedService;
//# sourceMappingURL=markItemsAsPinnedService.js.map

/***/ }),

/***/ 3823:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var markItemsAsPinnedService_1 = __webpack_require__(3822);
var markItemsAsPinnedStoreUpdate_1 = __webpack_require__(799);
var owa_mail_list_store_1 = __webpack_require__(5);
var undoActions = __webpack_require__(214);
var legacy_1 = __webpack_require__(1);
/**
 * Pin or unpin items
 * @param rowKeys the row keys
 * @param tableView that the pinned/unpinned items are in
 * @param shouldMarkAsPinned the pin value to be set
 * @param actionSource the action source
 */
exports.default = legacy_1.action('pinItems', datapoints_1.default.pinItemsDatapoint)(function pinItems(rowKeys, tableView, shouldMarkAsPinned, actionSource) {
    undoActions.clearLastUndoableAction();
    // Get all the row keys to update by checking if the existing pinned value is the same as the one to set
    var filteredRowKeys = filterRowKeysByPinValue(rowKeys, tableView, shouldMarkAsPinned);
    // Get the dedupped item ids to update, as multiple rowKeys could map to the same rowId
    var itemIdStringsToUpdate = owa_mail_list_store_1.getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    if (itemIdStringsToUpdate.length == 0) {
        // No need to send out the service call
        return Promise.resolve();
    }
    markItemsAsPinnedStoreUpdate_1.default(filteredRowKeys, tableView.id, shouldMarkAsPinned);
    // Make service request
    // Task 658: Reload client state when pin action fails on the server
    markItemsAsPinnedService_1.default(itemIdStringsToUpdate, shouldMarkAsPinned);
    // return the promise to catch the end to end time of pinItemsDatapoint
    return Promise.resolve();
});
/**
 * Filter the row keys to update by the pin value
 * @param rowKeys to pin/unpin
 * @param tableView that the rows belong to
 * @param shouldMarkAsPinned isPinned value to be set
 */
function filterRowKeysByPinValue(rowKeys, tableView, shouldMarkAsPinned) {
    var filteredRowKeys = [];
    rowKeys.forEach(function (rowKey) {
        if ((owa_mail_list_store_1.MailRowDataPropertyGetter.getIsPinned(rowKey, tableView) && !shouldMarkAsPinned) ||
            (!owa_mail_list_store_1.MailRowDataPropertyGetter.getIsPinned(rowKey, tableView) && shouldMarkAsPinned)) {
            filteredRowKeys.push(rowKey);
        }
    });
    return filteredRowKeys;
}
//# sourceMappingURL=pinItems.js.map

/***/ }),

/***/ 3824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Filter the row keys by existence in the table
 * @param rowKeys to be filtered
 * @param tableView that used to be a reference
 * @returns filtered row keys if the key presents in the tableView.rowKeys
 */
function filterRowKeysByExistence(rowKeys, tableView) {
    return rowKeys.filter(function (rowKey) { return tableView.rowKeys.indexOf(rowKey) >= 0; });
}
exports.default = filterRowKeysByExistence;
//# sourceMappingURL=filterRowKeysByExistence.js.map

/***/ }),

/***/ 3825:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getServiceItemIds_1 = __webpack_require__(3193);
var reportMessageToSafetyLibraryOperation_1 = __webpack_require__(5612);
/**
 * Report the message to safety library service
 * @param itemIds the itemIds to update
 * @param safetyApiAction the safetyApiAction type
 * @param actionData the action data
 * @return the ReportMessageToSafetyLibraryResponse
 */
function reportMessageToSafetyLibraryService(itemIdsToUpdate, safetyApiAction, actionData) {
    var requestBody = {
        ItemIds: getServiceItemIds_1.default(itemIdsToUpdate),
        ReportAction: safetyApiAction,
    };
    if (actionData) {
        requestBody.ActionData = actionData;
    }
    return reportMessageToSafetyLibraryOperation_1.default(requestBody).then(function (response) {
        return response.ReportSucccess[0];
    });
}
exports.default = reportMessageToSafetyLibraryService;
//# sourceMappingURL=reportMessageToSafetyLibraryService.js.map

/***/ }),

/***/ 3826:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(25);
var moveConversationToFocusedOrOther_1 = __webpack_require__(5617);
var moveItemsToFocusedOrOther_1 = __webpack_require__(5626);
function moveMailListRowsToFocusedOrOtherAction(rowKeys, originalTableViewId, actionSource) {
    var tableView = Store_1.default.tableViews.get(originalTableViewId);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            moveConversationToFocusedOrOther_1.default(rowKeys, originalTableViewId, actionSource);
            break;
        case 1 /* Message */:
            moveItemsToFocusedOrOther_1.default(rowKeys, originalTableViewId, actionSource);
            break;
    }
}
exports.default = moveMailListRowsToFocusedOrOtherAction;
//# sourceMappingURL=moveMailListRowsToFocusedOrOther.js.map

/***/ }),

/***/ 3827:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
owa_bundling_1.preloadScriptChunk('InferenceTracking');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 5619));
});
/**
 * This is the function consumers should call when preparing data to log to inference API
 * via @see logCustomDataLoggerDatapoint or @see logUsage.
 * Note that inference APIs do not care about conversationIds -- they do not help train the
 * inference model and will be discarded! -- so you must first make a call to grab itemIds.
 * To prevent any bias in the data from lazy loading, you will also need to make the activity
 * time call inline. You can just copy: new Date().toISOString()
 */
exports.lazyBuildInferenceDatapoint = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.buildInferenceDatapoint; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3831:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var applyBulkItemActionJsonRequest_1 = __webpack_require__(5630);
function applyBulkItemActionOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = applyBulkItemActionJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("ApplyBulkItemAction", req, options);
}
exports.default = applyBulkItemActionOperation;


/***/ }),

/***/ 3832:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(17);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setClientOptedIn')(function setOptedIn(optedIn) {
    Store_1.getStore().clientOptedIn = optedIn;
});
//# sourceMappingURL=setClientOptedIn.js.map

/***/ }),

/***/ 3833:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function createSweepRuleForSenderRequest(data) {
    var result = tslib_1.__assign({ __type: 'CreateSweepRuleForSenderRequest:#Exchange' }, data);
    return result;
}
exports.default = createSweepRuleForSenderRequest;


/***/ }),

/***/ 3834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var createSweepRuleForSenderJsonRequest_1 = __webpack_require__(5646);
function createSweepRuleForSenderOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = createSweepRuleForSenderJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("CreateSweepRuleForSender", req, options);
}
exports.default = createSweepRuleForSenderOperation;


/***/ }),

/***/ 3835:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var undoActions = __webpack_require__(214);
var datapoints_1 = __webpack_require__(2625);
var getDeleteAllConfirmText_1 = __webpack_require__(5647);
var getItemIdsFromConversations_1 = __webpack_require__(3194);
var isFolderUnderDeletedFolder_1 = __webpack_require__(3169);
var owa_mail_strings_1 = __webpack_require__(22);
var legacy_1 = __webpack_require__(1);
var actionTypes_1 = __webpack_require__(74);
var owa_confirm_dialog_1 = __webpack_require__(223);
var emptyFolderService_1 = __webpack_require__(5648);
var owa_strings_1 = __webpack_require__(20);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_service_error_1 = __webpack_require__(152);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_bulk_action_store_1 = __webpack_require__(1720);
var owa_analytics_1 = __webpack_require__(12);
var stitch_1 = __webpack_require__(44);
/**
 * Get the type of items to delete based on view filter
 * @param viewFilter the view filter
 * @returns the text which indicates type of items to delete based on the view filter
 */
function getItemsTypeText(viewFilter) {
    switch (viewFilter) {
        case 'Unread':
            return owa_mail_strings_1.default.allUnreadItems;
        case 'Flagged':
            return owa_mail_strings_1.default.allFlaggedItems;
        case 'ToOrCcMe':
            return owa_mail_strings_1.default.allToMeItems;
        case 'All':
        default:
            return owa_mail_strings_1.default.allItems;
    }
}
/**
 * Get the folder scope text
 * @param focusedViewFilter the focused view filter
 * @param folderDisplayName the folder display name
 * @returns the folder scope text, e.g Focused Inbox, Other Inbox, Sent Items, etc.
 */
function getFolderScopeText(focusedViewFilter, folderDisplayName) {
    var focusedViewFilterText = '';
    switch (focusedViewFilter) {
        case 0 /* Focused */:
            focusedViewFilterText = owa_mail_strings_1.default.focusedViewFilterText + ' ';
            break;
        case 1 /* Other */:
            focusedViewFilterText = owa_mail_strings_1.default.otherViewFilterText + ' ';
            break;
    }
    return focusedViewFilterText + folderDisplayName;
}
/**
 * Empty folder without the confirm dialog
 * @param folder the folder to be emptied
 * @param disposalType the disposalType
 * @param clientLastSyncTime client last sync time used as a watermark
 * @param rowKeysToExclude item ids to exclude from empty folder operation
 */
var emptyFolderWithoutConfirmation = legacy_1.action('emptyFolderWithoutConfirmation')(function emptyFolderWithoutConfirmation(folder, disposalType, deleteSubFolders, clientLastSyncTime, rowKeysToExclude, tableViewId) {
    var itemIdsToExclude = rowKeysToExclude
        ? getItemIdsFromConversations_1.default(rowKeysToExclude, tableViewId)
        : [];
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = owa_service_error_1.handleServiceError('emptyFolderWithoutConfirmation', owa_strings_1.format(owa_mail_strings_1.default.errorEmptyingFolder, folder.DisplayName), function () {
        return emptyFolderService_1.emptyFolderService(folder, disposalType, deleteSubFolders, clientLastSyncTime, itemIdsToExclude);
    }, undefined, function () {
        owa_bulk_action_store_1.lazyOnBulkActionFailure.importAndExecute(folder.FolderId.Id, owa_strings_1.format(owa_mail_strings_1.default.errorEmptyingFolder, folder.DisplayName));
    });
    stitch_1.raiseAction(actionTypes_1.actionNames.EmptyFolderStoreUpdate)(folder, clientLastSyncTime, rowKeysToExclude);
    return actionResponse;
});
var emptyFolderActionName = 'emptyFolderAction';
exports.emptyFolderActionName = emptyFolderActionName;
/**
 * Delete all conversations or items in the specified folder
 * @param folder the folder to be emptied
 * @param focusedViewFilter the focused view filter
 * @param viewFilter the view filter
 * @param isExplicitSoftDelete flag to indicate whether disposal type is soft delete
 * @param clientLastSyncTime client last sync time used as a watermark
 * @param rowKeysToExclude row keyss to exclude from empty folder operation
 */
exports.default = legacy_1.action(emptyFolderActionName)(function emptyFolder(folder, focusedViewFilter, viewFilter, isExplicitSoftDelete, actionSource, rowKeysToExclude, clientLastSyncTime, tableViewId) {
    var _this = this;
    var confirmEmptyFolderSubtext;
    var disposalType;
    var deleteSubFolders;
    undoActions.clearLastUndoableAction();
    var folderScopeText = getFolderScopeText(focusedViewFilter, folder.DisplayName);
    var itemsTypeText = getItemsTypeText(viewFilter);
    var exclusionListCount = rowKeysToExclude ? rowKeysToExclude.length : 0;
    if (folder.distinguishedFolderId == 'deleteditems' ||
        folder.distinguishedFolderId == 'junkemail') {
        confirmEmptyFolderSubtext = owa_strings_1.format(owa_mail_strings_1.default.confirmPermanentEmptyFolderSubText, itemsTypeText, folderScopeText);
        deleteSubFolders = !owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl');
        // This is to ensure the contract on server that clientLastSyncTime and deleteSubFolders cannot be present at the same time
        clientLastSyncTime = deleteSubFolders ? null : clientLastSyncTime;
        disposalType = 'SoftDelete';
    }
    else if (isFolderUnderDeletedFolder_1.default(folder)) {
        confirmEmptyFolderSubtext = owa_strings_1.format(owa_mail_strings_1.default.confirmEmptyFolderForFolderUnderDeletedItemsSubText, itemsTypeText, folderScopeText);
        deleteSubFolders = false;
        disposalType = 'SoftDelete';
    }
    else {
        if (isExplicitSoftDelete) {
            confirmEmptyFolderSubtext = owa_strings_1.format(owa_mail_strings_1.default.confirmPermanentEmptyFolderSubText, itemsTypeText, folder.DisplayName);
            disposalType = 'SoftDelete';
        }
        else {
            confirmEmptyFolderSubtext = owa_strings_1.format(owa_mail_strings_1.default.confirmEmptyFolderSubText, itemsTypeText, folderScopeText);
            disposalType = 'MoveToDeletedItems';
        }
        deleteSubFolders = false;
    }
    return owa_confirm_dialog_1.confirm(getDeleteAllConfirmText_1.default(actionSource, owa_mail_list_store_1.getListViewTypeForFolder(folder.FolderId.Id) /* listViewType */, folder.TotalCount - exclusionListCount, folder), confirmEmptyFolderSubtext, false /* resolveImmediately */, {
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
        okText: owa_mail_strings_1.default.confirmEmptyFolderText,
    }).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (response === 0 /* ok */) {
                owa_analytics_1.logUsage(datapoints_1.default.emptyFolderDatapoint.datapoint.name, [
                    actionSource,
                    folder.TotalCount,
                    disposalType,
                ]);
                return [2 /*return*/, emptyFolderWithoutConfirmation(folder, disposalType, deleteSubFolders, clientLastSyncTime, rowKeysToExclude, tableViewId)];
            }
            return [2 /*return*/];
        });
    }); });
});
//# sourceMappingURL=emptyFolder.js.map

/***/ }),

/***/ 3836:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getBlockSendersConfirmTitleAndSubtext_1 = __webpack_require__(5663);
var blockSenderService_1 = __webpack_require__(5664);
var owa_confirm_dialog_1 = __webpack_require__(223);
/**
 * Shows the confirm dialog before sending out the block service call
 * @param mailboxes to block
 * @param blockActionCallback to be called upon sending out the service call
 */
function blockLastSendersHelper(mailboxes, blockActionCallback) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, title, subtext, confirmResponse;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!mailboxes) {
                        // Do nothing in case of invalid mailboxes,
                        // i.e mailboxes is null when user tries to block self
                        return [2 /*return*/];
                    }
                    _a = getBlockSendersConfirmTitleAndSubtext_1.default(mailboxes), title = _a[0], subtext = _a[1];
                    return [4 /*yield*/, owa_confirm_dialog_1.confirm(title, subtext)];
                case 1:
                    confirmResponse = _b.sent();
                    if (confirmResponse !== 0 /* ok */) {
                        return [2 /*return*/];
                    }
                    try {
                        blockSenderService_1.default(mailboxes);
                    }
                    catch (error) {
                        // VSO 19006: Handle service error caused by block
                    }
                    blockActionCallback();
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = blockLastSendersHelper;
//# sourceMappingURL=blockLastSendersHelper.js.map

/***/ }),

/***/ 5580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getEwsRequestDateString_1 = __webpack_require__(693);
var getServiceContextFolderId_1 = __webpack_require__(697);
var applyConversationActionRequest_1 = __webpack_require__(685);
var conversationAction_1 = __webpack_require__(686);
var itemId_1 = __webpack_require__(94);
var applyConversationActionOperation_1 = __webpack_require__(687);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Create a ConversationAction with delete params for a given conversation.
 * @param conversationContext the conversation context to be deleted
 * @param contextFolderId  the folder where the conversations will be deleted from
 * @param disposalType  the disposal type
 * @returns a ConversationAction
 */
function createDeleteConversationAction(conversationContext, contextFolderId, disposalType) {
    return conversationAction_1.default({
        Action: 'Delete',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        DeleteType: disposalType,
        ConversationLastSyncTime: getEwsRequestDateString_1.default(conversationContext.conversationLastSyncTimeStamp),
        SuppressReadReceipts: true,
        ContextFolderId: getServiceContextFolderId_1.default(contextFolderId),
    });
}
/**
 * Worker method which converts the provided data into a delete ApplyConversationActionRequest.
 * @param conversationContexts the conversation contexts to be deleted
 * @param contextFolderId  the folder where the conversations will be deleted from
 * @param disposalType the disposal type
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationContexts, contextFolderId, disposalType) {
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createDeleteConversationAction(conversationContext, contextFolderId, disposalType);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}
/**
 * The service which calls the ApplyConversationAction with delete parameters.
 * @param conversationContexts the conversation contexts to be deleted
 * @param contextFolderId  the folder where the conversations will be deleted from
 * @param disposalType the disposal type
 */
function deleteConversationService(conversationContexts, contextFolderId, disposalType, options) {
    var requestBody = configureRequestBody(conversationContexts, contextFolderId, disposalType);
    return applyConversationActionOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }, options).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = deleteConversationService;
//# sourceMappingURL=deleteConversationService.js.map

/***/ }),

/***/ 5581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var applyMessageActionOperation_1 = __webpack_require__(5582);
var Utils_1 = __webpack_require__(362);
var applyMessageActionRequest_1 = __webpack_require__(5584);
var messageAction_1 = __webpack_require__(5585);
var itemId_1 = __webpack_require__(94);
/**
 * Restore item service
 * @param itemIds the itemIds to be restored
 * @return the ApplyMessageActionResponseMessage
 */
function restoreItemService(itemIds) {
    var requestBody = configureRequestBody(itemIds);
    return applyMessageActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = restoreItemService;
/**
 * Configure the request body
 * @param itemIds the itemIds to be restored
 * @return the ApplyMessageActionResponseMessage body
 */
function configureRequestBody(itemIds) {
    return applyMessageActionRequest_1.default({
        MessageAction: messageAction_1.default({
            Action: 'Restore',
        }),
        Ids: itemIds.map(function (itemIdValue) { return itemId_1.default({ Id: itemIdValue }); }),
    });
}
//# sourceMappingURL=restoreItemService.js.map

/***/ }),

/***/ 5582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var applyMessageActionJsonRequest_1 = __webpack_require__(5583);
function applyMessageActionOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = applyMessageActionJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("ApplyMessageAction", req, options);
}
exports.default = applyMessageActionOperation;


/***/ }),

/***/ 5583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function applyMessageActionJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'ApplyMessageActionJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = applyMessageActionJsonRequest;


/***/ }),

/***/ 5584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function applyMessageActionRequest(data) {
    var result = tslib_1.__assign({ __type: 'ApplyMessageActionRequest:#Exchange' }, data);
    return result;
}
exports.default = applyMessageActionRequest;


/***/ }),

/***/ 5585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function messageAction(data) {
    var result = tslib_1.__assign({ __type: 'MessageAction:#Exchange' }, data);
    return result;
}
exports.default = messageAction;


/***/ }),

/***/ 5586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setMailListRowsFlagState_1 = __webpack_require__(3816);
var legacy_1 = __webpack_require__(1);
var owa_mail_list_store_1 = __webpack_require__(5);
/**
 * Get the flag status to be set
 * @param rowKeys the conversation rowkeys
 * @param tableViewId the table view
 * @return the flag status to be set
 */
function getFlagStatusToSet(rowKeys, tableView) {
    var flagStatus = 'NotFlagged';
    // Set the flag status to 'Flagged' if there is any non-flagged conversation
    for (var i = 0; i < rowKeys.length; i++) {
        var rowFlagStatus = owa_mail_list_store_1.MailRowDataPropertyGetter.getFlagStatus(rowKeys[i], tableView);
        if (rowFlagStatus != 'Flagged') {
            flagStatus = 'Flagged';
            break;
        }
    }
    return flagStatus;
}
/**
 * Toggle the given rows' flagged state
 * @param rowKeys the given rowkeys
 * @param tableViewId of the table that the row belong to
 */
exports.default = legacy_1.action('toggleRowsFlagState')(function toggleRowsFlagState(rowKeys, tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var flagStatusToSet = getFlagStatusToSet(rowKeys, tableView);
    setMailListRowsFlagState_1.default(rowKeys, tableViewId, flagStatusToSet);
});
//# sourceMappingURL=toggleRowsFlagState.js.map

/***/ }),

/***/ 5587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createSetItemField_1 = __webpack_require__(639);
var itemChange_1 = __webpack_require__(637);
var itemId_1 = __webpack_require__(94);
var updateItemRequest_1 = __webpack_require__(635);
var updateItemOperation_1 = __webpack_require__(636);
var ServiceRequestUtils_1 = __webpack_require__(31);
function createRequestBody(itemIds, flagStatus) {
    var update = createSetItemField_1.default('Flag', { FlagStatus: flagStatus });
    var itemChanges = [];
    itemIds.forEach(function (id) {
        return itemChanges.push(itemChange_1.default({
            Updates: [update],
            ItemId: itemId_1.default({ Id: id }),
        }));
    });
    return updateItemRequest_1.default({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}
function flagItemService(itemIds, flagStatus) {
    var requestBody = createRequestBody(itemIds, flagStatus);
    return updateItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = flagItemService;
//# sourceMappingURL=flagItemService.js.map

/***/ }),

/***/ 5588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var setRowsFlagStateHelper_1 = __webpack_require__(3818);
var applyConversationFlag_1 = __webpack_require__(5589);
var owa_mail_list_store_1 = __webpack_require__(5);
var Store_1 = __webpack_require__(25);
var flagConversationService_1 = __webpack_require__(5591);
var owa_service_error_1 = __webpack_require__(152);
var owa_mail_strings_1 = __webpack_require__(22);
var legacy_1 = __webpack_require__(1);
var stitch_1 = __webpack_require__(44);
var owa_mail_store_1 = __webpack_require__(38);
var owa_mail_actions_1 = __webpack_require__(238);
var SetConversationsFlagStateActionName = 'setConversationsFlagState';
/**
 * Set the specified flag state on a collection of conversations.
 * @param conversationRowKeys - the converations row keys
 * @param tableViewId - the table view the conversations are in
 * @param flagType - the specified flag type to set
 */
var setConversationsFlagStateInternal = legacy_1.action(SetConversationsFlagStateActionName, datapoints_1.default.setConversationsFlagStateDatapoint)(function setConversationsFlagStateInternal(conversationRowKeys, instrumentationContexts, tableViewId, flagStatusToApply) {
    var conversationIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(conversationRowKeys, tableViewId);
    owa_service_error_1.handleServiceError(SetConversationsFlagStateActionName, owa_mail_strings_1.default.errorFlaggingConversation, function () {
        var conversationActionContexts = conversationRowKeys.map(function (rowKey) {
            return owa_mail_list_store_1.getApplyConversationActionContext(rowKey, tableViewId);
        });
        var flagType = {
            FlagStatus: flagStatusToApply,
        };
        // update list view store
        applyConversationFlag_1.default(conversationRowKeys, flagType, tableViewId);
        // update reading pane store
        stitch_1.raiseAction(owa_mail_store_1.ApplyConversationFlagStateStoreUpdateActionName)(conversationIdStrings, flagType, tableViewId);
        var tableView = Store_1.default.tableViews.get(tableViewId);
        // Do not specify folderId in search, so that action is global to the same conversation in all folders.
        var sourceFolderId = tableView.serverFolderId;
        var instrumentationFlag;
        switch (flagStatusToApply) {
            case 'Flagged':
                instrumentationFlag = 'Flag';
                break;
            case 'NotFlagged':
                instrumentationFlag = 'FlagCleared';
                break;
            case 'Complete':
                instrumentationFlag = 'FlagComplete';
                break;
        }
        owa_mail_actions_1.userMailInteractionAction(instrumentationFlag, instrumentationContexts);
        return flagConversationService_1.flagConversationService(conversationActionContexts, flagType, sourceFolderId);
    });
});
/**
 * Set the specified flag state on a collection of conversations.
 * @param conversationRowKeys - the converations row keys
 * @param tableViewId - the table view the conversations are in
 * @param flagType - the specified flag type to set
 */
function setConversationsFlagState(conversationRowKeys, instrumentationContexts, tableViewId, flagStatusToApply) {
    setRowsFlagStateHelper_1.default(conversationRowKeys, tableViewId, flagStatusToApply, function (rowKeys, flagStatusToApply) {
        setConversationsFlagStateInternal(rowKeys, instrumentationContexts, tableViewId, flagStatusToApply);
    });
}
exports.default = setConversationsFlagState;
//# sourceMappingURL=setConversationsFlagState.js.map

/***/ }),

/***/ 5589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateConversationRelations_1 = __webpack_require__(5590);
var Store_1 = __webpack_require__(25);
var owa_mail_list_store_1 = __webpack_require__(5);
var legacy_1 = __webpack_require__(1);
/**
 * Apply flag state on the conversations in list view store
 * @param rowKeys for the conversations
 * @param flagType the flag type to apply
 * @param tableViewId the table view id
 * @param state the ApplyConversationFlagInListViewStore state used for this action
 */
exports.default = legacy_1.select({
    tableViews: function () { return Store_1.default.tableViews; },
})(legacy_1.action('ApplyConversationFlagInListViewStore')(function applyConversationFlag(rowKeys, flagType, tableViewId, state) {
    if (!flagType || !flagType.FlagStatus) {
        throw new Error('Invalid flag type.');
    }
    var tableView = state.tableViews.get(tableViewId);
    // Create the map to hold all unique item ids.
    // This is used to update tableConversationRelation in other table views.
    var itemIdsToUpdate = {};
    // Gather the item ids to be updated by going through each conversation
    rowKeys.forEach(function (rowKey) {
        var tableConversationRelation = owa_mail_list_store_1.getTableConversationRelation(rowKey, tableView.id);
        if (flagType.FlagStatus == 'Flagged') {
            // For mark as flag, only flag the latest item in the conversation and put it in the map.
            // It is always the first item in the itemIds array in FindConversation response,
            // regardless of the conversationSortOrder(NewestOnBottom or NewestOnTop).
            var latestItemId = tableConversationRelation.itemIds[0];
            itemIdsToUpdate[latestItemId] = 1;
        }
        else {
            // For unflagging or complete, apply to all items in this conversation
            tableConversationRelation.itemIds.forEach(function (itemId) {
                itemIdsToUpdate[itemId] = 1;
            });
        }
    });
    // Update the tableConversationRelation in all table views of the current folder
    var rowIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, tableView.id);
    updateConversationRelations_1.default(rowIdStrings, tableView.serverFolderId, itemIdsToUpdate, function (relation, itemId) {
        relation.flagStatus = flagType.FlagStatus;
    });
}));
//# sourceMappingURL=applyConversationFlag.js.map

/***/ }),

/***/ 5590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_list_store_1 = __webpack_require__(5);
var legacy_1 = __webpack_require__(1);
// Helper funtion that finds the conversations from all the tables matching
// the folderId and also containing the item id that is passed.
// It then calls the callback to apply the triage action.
// VSO 1458 - we should do the same for pinning and mark junk actions
exports.default = legacy_1.select({
    tableViewConversationRelations: function () { return owa_mail_list_store_1.listViewStore.tableViewConversationRelations; },
    tableViews: function () { return owa_mail_list_store_1.listViewStore.tableViews; },
})(function updateConversationRelations(conversationRowIds, folderId, itemIdsToUpdate, customUpdateFunction, state) {
    conversationRowIds.forEach(function (rowId) {
        state.tableViews.forEach(function (tableView) {
            if (tableView.serverFolderId == folderId) {
                var rowKeys = owa_mail_list_store_1.getRowKeysFromRowIds([rowId], tableView);
                rowKeys.forEach(function (rowKey) {
                    var tableConversationRelation = owa_mail_list_store_1.getTableConversationRelation(rowKey, tableView.id);
                    // The tableConversationRelation can be null, for example,
                    // a read conversation won't be in the unread table view
                    if (!tableConversationRelation) {
                        return;
                    }
                    tableConversationRelation.itemIds.forEach(function (itemId) {
                        // apply the custom update action only if the tableConversationRelation has the specified item.
                        if (itemIdsToUpdate[itemId]) {
                            customUpdateFunction(tableConversationRelation, itemId);
                        }
                    });
                });
            }
        });
    });
});
//# sourceMappingURL=updateConversationRelations.js.map

/***/ }),

/***/ 5591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getEwsRequestDateString_1 = __webpack_require__(693);
var applyConversationActionRequest_1 = __webpack_require__(685);
var conversationAction_1 = __webpack_require__(686);
var folderId_1 = __webpack_require__(47);
var itemId_1 = __webpack_require__(94);
var targetFolderId_1 = __webpack_require__(156);
var applyConversationActionOperation_1 = __webpack_require__(687);
var Utils_1 = __webpack_require__(362);
/**
 * Create the flag conversationAction for the given conversation
 * @param conversationContext the conversation context to be flagged
 * @param flagType the flag type to apply
 * @param folderId the sourceFolderId
 * @returns the generated ConversationAction
 */
function createFlagConversationAction(conversationContext, flagType, folderId) {
    var flagAction = conversationAction_1.default({
        Action: 'Flag',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        Flag: flagType,
        ConversationLastSyncTime: getEwsRequestDateString_1.default(conversationContext.conversationLastSyncTimeStamp),
    });
    // folderId can be null in search mode.
    if (folderId) {
        var targetFolderId = targetFolderId_1.default({
            BaseFolderId: folderId_1.default({
                Id: folderId,
            }),
        });
        flagAction.ContextFolderId = targetFolderId;
    }
    return flagAction;
}
/**
 * Configure the request body
 * @param conversationIds the conversation ids
 * @param flagType the flag type to apply
 * @param folderId the folder id
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationContexts, flagType, folderId) {
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createFlagConversationAction(conversationContext, flagType, folderId);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
    });
}
/**
 * Sends out the service request to set flag on conversation
 * @param conversationContexts the conversation contexts to be deleted
 * @param flagType the flag type to apply
 * @param folderId the source folder id
 * @returns a Promise that handles the service request response
 */
function flagConversationService(conversationContexts, flagType, folderId) {
    var requestBody = configureRequestBody(conversationContexts, flagType, folderId);
    return applyConversationActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.flagConversationService = flagConversationService;
//# sourceMappingURL=flagConversationService.js.map

/***/ }),

/***/ 5592:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var datapoints_1 = __webpack_require__(2625);
var moveMailListRowsHelper_1 = __webpack_require__(3820);
var actionTypes_1 = __webpack_require__(74);
var moveConversationService_1 = __webpack_require__(5600);
var undoActions = __webpack_require__(214);
var legacy_1 = __webpack_require__(1);
var stitch_1 = __webpack_require__(44);
var owa_mail_list_store_1 = __webpack_require__(5);
/**
 * The action worker which handles moving conversations.
 * @param rowKeys - the row keys of the rows that, need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
exports.default = legacy_1.action('moveConversations', datapoints_1.default.moveConversationDatapoint)(function moveConversations(rowKeys, destinationFolderId, originalTableView, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, moveMailListRowsHelper_1.default(rowKeys, destinationFolderId, originalTableView, moveConversationsInternal, actionSource)];
        });
    });
});
/**
 * The move conversations internal method
 * @param rowKeys - the row keys of the rows that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
function moveConversationsInternal(rowKeys, destinationFolderId, originalTableView, sourceFolderId) {
    // Task 658: Reload client state when move conversation fails on the server.
    var conversationActionContexts = rowKeys.map(function (rowKey) {
        return owa_mail_list_store_1.getApplyConversationActionContext(rowKey, originalTableView.id);
    });
    var conversationIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, originalTableView.id);
    stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, originalTableView);
    // Make service request
    return (moveConversationService_1.default(conversationActionContexts, destinationFolderId, sourceFolderId)
        .then(function (response) {
        if (response.ResponseClass == 'Success') {
            undoActions.addActionToUndoStack(function () {
                return moveConversationService_1.default(conversationActionContexts, sourceFolderId, destinationFolderId);
            });
        }
        else {
            // VSO 21472: Error handling for triage actions
        }
    })
        .catch());
}
//# sourceMappingURL=moveConversations.js.map

/***/ }),

/***/ 5593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var copyItemsService_1 = __webpack_require__(5594);
var owa_mail_list_store_1 = __webpack_require__(5);
var copyConversationService_1 = __webpack_require__(5598);
var legacy_1 = __webpack_require__(1);
/**
 * Copy the mail list rows to a destination folder
 * @param rowKeys of the rows to copy
 * @param originalTableView which contains the rows to move from
 * @param destinationFolderId id of the destination folder to move to
 * @param sourceFolderId the actual source folder that contains the rows
 */
exports.default = legacy_1.action('copyMailListRows')(function copyMailListRows(rowKeys, originalTableView, destinationFolderId, sourceFolderId) {
    switch (originalTableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            var conversationActionContext = rowKeys.map(function (rowKey) {
                return owa_mail_list_store_1.getApplyConversationActionContext(rowKey, originalTableView.id);
            });
            copyConversationService_1.default(conversationActionContext, destinationFolderId, sourceFolderId)
                .catch();
            break;
        case 1 /* Message */:
            var rowIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, originalTableView.id);
            copyItemsService_1.default(rowIdStrings, destinationFolderId)
                .catch();
            break;
    }
});
//# sourceMappingURL=copyMailListRows.js.map

/***/ }),

/***/ 5594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getServiceContextFolderId_1 = __webpack_require__(697);
var getServiceItemIds_1 = __webpack_require__(3193);
var copyItemRequest_1 = __webpack_require__(5595);
var copyItemOperation_1 = __webpack_require__(5596);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * The service command to copy items to a specified destination folder
 * @param itemIds the ids of the items to be copied
 * @param destinationFolderId the id of destination folder to copy to
 * @return a Promise which contains the CopyItemResponse
 */
function copyItemsService(itemIds, destinationFolderId) {
    var requestBody = configureRequestBody(itemIds, destinationFolderId);
    return copyItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = copyItemsService;
/**
 * Configure the CopyItemRequest body
 * @param itemIds the ids of the items to be copied
 * @param destinationFolderId the id of destination folder to copy to
 * @return the CopyItemRequest body
 */
function configureRequestBody(itemIds, destinationFolderId) {
    return copyItemRequest_1.default({
        ToFolderId: getServiceContextFolderId_1.default(destinationFolderId),
        ItemIds: getServiceItemIds_1.default(itemIds),
        ReturnNewItemIds: true,
    });
}
//# sourceMappingURL=copyItemsService.js.map

/***/ }),

/***/ 5595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function copyItemRequest(data) {
    var result = tslib_1.__assign({ __type: 'CopyItemRequest:#Exchange' }, data);
    return result;
}
exports.default = copyItemRequest;


/***/ }),

/***/ 5596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var copyItemJsonRequest_1 = __webpack_require__(5597);
function copyItemOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = copyItemJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("CopyItem", req, options);
}
exports.default = copyItemOperation;


/***/ }),

/***/ 5597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function copyItemJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'CopyItemJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = copyItemJsonRequest;


/***/ }),

/***/ 5598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getEwsRequestDateString_1 = __webpack_require__(693);
var applyConversationActionRequest_1 = __webpack_require__(685);
var conversationAction_1 = __webpack_require__(686);
var folderId_1 = __webpack_require__(47);
var itemId_1 = __webpack_require__(94);
var targetFolderId_1 = __webpack_require__(156);
var applyConversationActionOperation_1 = __webpack_require__(687);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Create a ConversationAction with move params for a given conversation.
 * @param conversationContext the conversation context to be copied
 * @param currentFolderTargetId - the table view the conversations are moving from (null for search)
 * @param destinationFolderTargetId - the folder they need to go to
 */
function createCopyConversationAction(conversationContext, currentFolderTargetId, destinationFolderTargetId) {
    return conversationAction_1.default({
        Action: 'Copy',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        ContextFolderId: currentFolderTargetId,
        DestinationFolderId: destinationFolderTargetId,
        ConversationLastSyncTime: getEwsRequestDateString_1.default(conversationContext.conversationLastSyncTimeStamp),
    });
}
/**
 * Worker method which converts the provided data into an ApplyConversationActionRequest.
 * @param conversationContexts the conversation contexts to be copied
 * @param destinationFolderId - the folder they need to move to
 * @param currentFolderId - the folder they originate in -- null for search scenarios
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationContexts, destinationFolderId, currentFolderId) {
    var destinationFolderTargetId = targetFolderId_1.default({
        BaseFolderId: folderId_1.default({ Id: destinationFolderId }),
    });
    // This is a workaround for the fact that in search scenarios we need to pass a completely null ContextFolderId
    // (not the BaseFolderId form in the false condition of the ternary) in all conversationActions.
    var currentFolderTargetId = currentFolderId == null
        ? null
        : targetFolderId_1.default({ BaseFolderId: folderId_1.default({ Id: currentFolderId }) });
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createCopyConversationAction(conversationContext, currentFolderTargetId, destinationFolderTargetId);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: true,
    });
}
/**
 * The service which calls the ApplyConversationAction with move parameters.
 * @param conversationContexts the conversation contexts to be copied
 * @param destinationFolderId - the folder they need to move to
 * @param currentFolderId - the folder they originate in -- null for search scenarios
 */
function copyConversationService(conversationContexts, destinationFolderId, currentFolderId) {
    var requestBody = configureRequestBody(conversationContexts, destinationFolderId, currentFolderId);
    return applyConversationActionOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = copyConversationService;
//# sourceMappingURL=copyConversationService.js.map

/***/ }),

/***/ 5599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isFolderOrSubFolderOfDistinguishedFolder_1 = __webpack_require__(2226);
var MoveKind;
(function (MoveKind) {
    MoveKind[MoveKind["Normal"] = 0] = "Normal";
    MoveKind[MoveKind["ShadowMailbox_Copy"] = 1] = "ShadowMailbox_Copy";
    MoveKind[MoveKind["ShadowMailbox_Delete"] = 2] = "ShadowMailbox_Delete";
})(MoveKind = exports.MoveKind || (exports.MoveKind = {}));
var isOrUnderJunkOrDeleted = function (folder) {
    return isFolderOrSubFolderOfDistinguishedFolder_1.default(folder, 'deleteditems') ||
        isFolderOrSubFolderOfDistinguishedFolder_1.default(folder, 'junkemail');
};
exports.default = function (isShadowMailbox, sourceFolder, destinationFolder) {
    if (!isShadowMailbox) {
        return 0 /* Normal */;
    }
    else if (sourceFolder.sourceWellKnownFolderType == 86 /* AllMail */ &&
        !isOrUnderJunkOrDeleted(destinationFolder)) {
        return 1 /* ShadowMailbox_Copy */;
    }
    else if (!isOrUnderJunkOrDeleted(sourceFolder) &&
        destinationFolder.sourceWellKnownFolderType == 86 /* AllMail */) {
        return 2 /* ShadowMailbox_Delete */;
    }
    else {
        return 0 /* Normal */;
    }
};
//# sourceMappingURL=getMoveKind.js.map

/***/ }),

/***/ 5600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getEwsRequestDateString_1 = __webpack_require__(693);
var applyConversationActionRequest_1 = __webpack_require__(685);
var conversationAction_1 = __webpack_require__(686);
var folderId_1 = __webpack_require__(47);
var itemId_1 = __webpack_require__(94);
var targetFolderId_1 = __webpack_require__(156);
var applyConversationActionOperation_1 = __webpack_require__(687);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * Create a ConversationAction with move params for a given conversation.
 * @param conversationContext the conversation context to be moved
 * @param currentFolderTargetId - the table view the conversations are moving from (null for search)
 * @param destinationFolderTargetId - the folder they need to go to
 */
function createMoveConversationAction(conversationContext, currentFolderTargetId, destinationFolderTargetId) {
    return conversationAction_1.default({
        Action: 'Move',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        ContextFolderId: currentFolderTargetId,
        DestinationFolderId: destinationFolderTargetId,
        ConversationLastSyncTime: getEwsRequestDateString_1.default(conversationContext.conversationLastSyncTimeStamp),
    });
}
/**
 * Worker method which converts the provided data into an ApplyConversationActionRequest.
 * @param conversationContexts the conversation contexts to be moved
 * @param destinationFolderId - the folder they need to move to
 * @param currentFolderId - the folder they originate in -- null for search scenarios
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationContexts, destinationFolderId, currentFolderId) {
    var destinationFolderTargetId = targetFolderId_1.default({
        BaseFolderId: folderId_1.default({ Id: destinationFolderId }),
    });
    // This is a workaround for the fact that in search scenarios we need to pass a completely null ContextFolderId
    // (not the BaseFolderId form in the false condition of the ternary) in all conversationActions.
    var currentFolderTargetId = currentFolderId == null
        ? null
        : targetFolderId_1.default({ BaseFolderId: folderId_1.default({ Id: currentFolderId }) });
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createMoveConversationAction(conversationContext, currentFolderTargetId, destinationFolderTargetId);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: true,
    });
}
/**
 * The service which calls the ApplyConversationAction with move parameters.
 * @param conversationContexts the conversation contexts to be moved
 * @param destinationFolderId - the folder they need to move to
 * @param currentFolderId - the folder they originate in -- null for search scenarios
 */
function moveConversationService(conversationContexts, destinationFolderId, currentFolderId) {
    var requestBody = configureRequestBody(conversationContexts, destinationFolderId, currentFolderId);
    return applyConversationActionOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = moveConversationService;
//# sourceMappingURL=moveConversationService.js.map

/***/ }),

/***/ 5601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var datapoints_1 = __webpack_require__(2625);
var moveMailListRowsHelper_1 = __webpack_require__(3820);
var moveItemsService_1 = __webpack_require__(5602);
var deleteItemsStoreUpdate_1 = __webpack_require__(239);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_mail_store_1 = __webpack_require__(38);
var undoActions = __webpack_require__(214);
var legacy_1 = __webpack_require__(1);
/**
 * The action worker which handles moving conversations.
 * @param conversationIds - the conversations that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the conversations are moving from
 */
exports.default = legacy_1.action('moveItems', datapoints_1.default.moveItemsDatapoint)(function moveItems(rowKeys, destinationFolderId, originalTableView, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, moveMailListRowsHelper_1.default(rowKeys, destinationFolderId, originalTableView, moveItemsInternal, actionSource)];
        });
    });
});
/**
 * The move items internal method
 * @param rowKeys - the row keys of the rows that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
function moveItemsInternal(rowKeys, destinationFolderId, originalTableView, sourceFolderId) {
    var itemIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, originalTableView.id);
    var itemContexts = itemIdStrings.map(function (itemIdValue) {
        var item = owa_mail_store_1.mailStore.items.get(itemIdValue);
        var isReadValue;
        if (owa_mail_list_store_1.isItemOfMessageType(item)) {
            isReadValue = item.IsRead;
        }
        else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
            isRead: isReadValue,
        };
    });
    // Dispatch action to update the store state
    deleteItemsStoreUpdate_1.default(itemContexts, sourceFolderId);
    // Make service request
    return moveItemsService_1.default(itemIdStrings, destinationFolderId, sourceFolderId)
        .then(function (moveItemResponse) {
        if (moveItemResponse.ResponseMessages) {
            addMovedItemsToUndoStack(moveItemResponse.ResponseMessages.Items, destinationFolderId, sourceFolderId);
        }
    })
        .catch();
}
function addMovedItemsToUndoStack(responseItems, destinationFolderId, sourceFolderId) {
    var movedItemIds = [];
    for (var _i = 0, responseItems_1 = responseItems; _i < responseItems_1.length; _i++) {
        var responseItem = responseItems_1[_i];
        if (responseItem.ResponseClass == 'Success') {
            movedItemIds.push(responseItem.Items[0].ItemId.Id);
        }
    }
    if (movedItemIds.length > 0) {
        undoActions.addActionToUndoStack(function () {
            // Reverse source folder id and destination folder id for undo
            return moveItemsService_1.default(movedItemIds, sourceFolderId, destinationFolderId);
        });
    }
}
//# sourceMappingURL=moveItems.js.map

/***/ }),

/***/ 5602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getServiceContextFolderId_1 = __webpack_require__(697);
var getServiceItemIds_1 = __webpack_require__(3193);
var moveItemRequest_1 = __webpack_require__(5603);
var moveItemOperation_1 = __webpack_require__(5604);
var ServiceRequestUtils_1 = __webpack_require__(31);
/**
 * The service command to move items to a specified destination folder
 * @param itemIds the ids of the items to be moved
 * @param destinationFolderId the id of destination folder to move to
 * @return a Promise which contains the MoveItemResponse
 */
function moveItemsService(itemIds, destinationFolderId, sourceFolderId) {
    var requestBody = configureRequestBody(itemIds, destinationFolderId);
    return moveItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = moveItemsService;
/**
 * Configure the MoveItemRequest body
 * @param itemIds the ids of the items to be moved
 * @param destinationFolderId the id of destination folder to move to
 * @return a Promise which contains the MoveItemResponse
 */
function configureRequestBody(itemIds, destinationFolderId) {
    return moveItemRequest_1.default({
        ToFolderId: getServiceContextFolderId_1.default(destinationFolderId),
        ItemIds: getServiceItemIds_1.default(itemIds),
        ReturnNewItemIds: true,
    });
}
//# sourceMappingURL=moveItemsService.js.map

/***/ }),

/***/ 5603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function moveItemRequest(data) {
    var result = tslib_1.__assign({ __type: 'MoveItemRequest:#Exchange' }, data);
    return result;
}
exports.default = moveItemRequest;


/***/ }),

/***/ 5604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var moveItemJsonRequest_1 = __webpack_require__(5605);
function moveItemOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = moveItemJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("MoveItem", req, options);
}
exports.default = moveItemOperation;


/***/ }),

/***/ 5605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function moveItemJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'MoveItemJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = moveItemJsonRequest;


/***/ }),

/***/ 5606:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var moveMailListRows_1 = __webpack_require__(3819);
var getUserConfiguration_1 = __webpack_require__(9);
var legacy_1 = __webpack_require__(1);
/**
 * Archive mail list rows from table
 * @param rowKeys the instance keys of the rows to archive
 * @param tableView the table view that contains the rows to archive
 * @param actionSource the action source that triggers the archive action
 */
exports.default = legacy_1.select({
    archiveFolderId: function () { return getUserConfiguration_1.default().UserOptions.ArchiveFolderId; },
})(legacy_1.action('archiveMailListRowsFromTable', datapoints_1.default.archiveMailListRowsDatapoint)(function archiveMailListRowsFromTable(rowKeys, tableView, actionSource, state) {
    if (state.archiveFolderId) {
        moveMailListRows_1.default(rowKeys, state.archiveFolderId, tableView.id, 'NonUserAction');
    }
    else {
        // For new accounts and the existing accounts which have not setup the archive folder
        // the archive folder should get created as a default folder.
        throw new Error('Archive folder id should always be set');
    }
}));
//# sourceMappingURL=archiveMailListRows.js.map

/***/ }),

/***/ 5607:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var pinConversations_1 = __webpack_require__(3821);
var pinItems_1 = __webpack_require__(3823);
var owa_mail_list_store_1 = __webpack_require__(5);
/**
 * Toggle the row pinned status
 * @param rowKey row key to pin/unpin
 * @param tableViewId of the table that the row belong to
 * @param actionSource the action source
 */
function toggleRowPinnedState(rowKey, tableViewId, actionSource) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var isRowPinned = owa_mail_list_store_1.MailRowDataPropertyGetter.getIsPinned(rowKey, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            pinConversations_1.default([rowKey], tableView, !isRowPinned, actionSource);
            break;
        case 1 /* Message */:
            pinItems_1.default([rowKey], tableView, !isRowPinned, actionSource);
            break;
    }
}
exports.default = toggleRowPinnedState;
//# sourceMappingURL=toggleRowPinnedState.js.map

/***/ }),

/***/ 5608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function deleteItemField(data) {
    var result = tslib_1.__assign({ __type: 'DeleteItemField:#Exchange' }, data);
    return result;
}
exports.default = deleteItemField;


/***/ }),

/***/ 5609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_list_store_1 = __webpack_require__(5);
var pinConversations_1 = __webpack_require__(3821);
var pinItems_1 = __webpack_require__(3823);
/**
 * Toggle the isPinned value of the rows
 * @param rowKeys to be pinned/unpinned
 * @param tableViewId the table view id
 * @param isPinnedToSet the isPinned value to be set
 * @param actionSource the action source
 */
function markRowsPinnedUnpinned(rowKeys, tableViewId, isPinnedToSet, actionSource) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            pinConversations_1.default(rowKeys, tableView, isPinnedToSet, actionSource);
            break;
        case 1 /* Message */:
            pinItems_1.default(rowKeys, tableView, isPinnedToSet, actionSource);
            break;
    }
}
exports.default = markRowsPinnedUnpinned;
//# sourceMappingURL=markRowsPinnedUnpinned.js.map

/***/ }),

/***/ 5610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var markConversationsAsPhishingFromTable_1 = __webpack_require__(5611);
var markItemsAsPhishingFromTable_1 = __webpack_require__(5614);
function markRowsAsPhishingFromTable(rowKeys, tableView, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            markConversationsAsPhishingFromTable_1.default(rowKeys, tableView, actionSource);
            break;
        case 1 /* Message */:
            markItemsAsPhishingFromTable_1.default(rowKeys, tableView, actionSource);
            break;
    }
}
exports.default = markRowsAsPhishingFromTable;
//# sourceMappingURL=markRowsAsPhishingFromTable.js.map

/***/ }),

/***/ 5611:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var confirmMarkAsPhishing_1 = __webpack_require__(3469);
var filterRowKeysByExistence_1 = __webpack_require__(3824);
var getInstrumentationContextsFromTableView_1 = __webpack_require__(215);
var getItemIdsFromConversations_1 = __webpack_require__(3194);
var markItemsAsPhishingBasedOnItemIds_1 = __webpack_require__(3470);
var actionTypes_1 = __webpack_require__(74);
var owa_mail_list_store_1 = __webpack_require__(5);
var stitch_1 = __webpack_require__(44);
var owa_mail_actions_1 = __webpack_require__(238);
/**
 * Mark the conversation as phishing with the confirm dialog
 * @param conversationRowKeys the specified conversation ids to be marked as phishing
 * @param tableView that contains the rows
 * @param actionSource the action source where this action is triggered from
 * @return a function which shows the confirmation dialog
 */
function markConversationsAsPhishingFromTable(conversationRowKeys, tableView, actionSource) {
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing_1.default(function () {
        markConversationsAsPhishingInternal(conversationRowKeys, tableView, actionSource);
    });
}
exports.default = markConversationsAsPhishingFromTable;
/**
 * mark conversations as phishing action
 * @param conversationRowKeys rowKeys for the specified conversations
 * @param tableView the table view id
 * @param actionSource the action source where this action is triggered from
 */
function markConversationsAsPhishingInternal(conversationRowKeys, tableView, actionSource) {
    // Since rows may have been deleted from the table while the confirm dialog was open,
    // we need to validate the rows exist before proceeding
    var filteredRowKeys = filterRowKeysByExistence_1.default(conversationRowKeys, tableView);
    if (filteredRowKeys.length == 0) {
        // Nothing to remove
        return;
    }
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(conversationRowKeys, tableView);
    // Get the de-duped conversation ids
    var conversationIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    // Get all itemIds inside the conversations
    var itemIdsToUpdate = getItemIdsFromConversations_1.default(filteredRowKeys, tableView.id);
    markItemsAsPhishingBasedOnItemIds_1.default(itemIdsToUpdate, actionSource, function () {
        // raise stitch to delete conversation from reading pane and list view
        stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, tableView);
    });
    owa_mail_actions_1.userMailInteractionAction('MarkAsPhishing', instrumentationContexts);
}
//# sourceMappingURL=markConversationsAsPhishingFromTable.js.map

/***/ }),

/***/ 5612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var reportMessageToSafetyLibraryRequest_1 = __webpack_require__(5613);
function reportMessageToSafetyLibraryOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = reportMessageToSafetyLibraryRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("ReportMessageToSafetyLibrary", req, options);
}
exports.default = reportMessageToSafetyLibraryOperation;


/***/ }),

/***/ 5613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function reportMessageToSafetyLibraryRequest(data) {
    var result = tslib_1.__assign({ __type: 'ReportMessageToSafetyLibraryRequest:#Exchange' }, data);
    return result;
}
exports.default = reportMessageToSafetyLibraryRequest;


/***/ }),

/***/ 5614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var confirmMarkAsPhishing_1 = __webpack_require__(3469);
var createItemContextsForDeleteStoreUpdate_1 = __webpack_require__(3114);
var deleteItemsStoreUpdate_1 = __webpack_require__(239);
var filterRowKeysByExistence_1 = __webpack_require__(3824);
var getInstrumentationContextsFromTableView_1 = __webpack_require__(215);
var markItemsAsPhishingBasedOnItemIds_1 = __webpack_require__(3470);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_mail_actions_1 = __webpack_require__(238);
/**
 * mark items as phishing given the row keys
 * @param rowKeys rowKeys for the specified conversations
 * @param tableView the table view id
 * @param actionSource the action source
 */
function markItemsAsPhishingFromTable(rowKeys, tableView, actionSource) {
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing_1.default(function () {
        markItemsAsPhishingInternal(rowKeys, tableView, actionSource);
    });
}
exports.default = markItemsAsPhishingFromTable;
/**
 * mark items as phishing internal handler
 * @param rowKeys rowKeys for the specified conversations
 * @param tableView the table view id
 * @param actionSource the action source
 */
function markItemsAsPhishingInternal(rowKeys, tableView, actionSource) {
    // Since rows may have been deleted from the table while the confirm dialog was open,
    // we need to validate the rows exist before proceeding
    var filteredRowKeys = filterRowKeysByExistence_1.default(rowKeys, tableView);
    if (filteredRowKeys.length == 0) {
        // Nothing to remove
        return;
    }
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(rowKeys, tableView);
    // Get the de-duped item ids from the row keys
    var itemIds = owa_mail_list_store_1.getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    markItemsAsPhishingBasedOnItemIds_1.default(itemIds, actionSource, function () {
        var itemContexts = createItemContextsForDeleteStoreUpdate_1.default(itemIds);
        // Dispatch action to update the store state
        deleteItemsStoreUpdate_1.default(itemContexts, tableView.tableQuery.folderId);
    });
    owa_mail_actions_1.userMailInteractionAction('MarkAsPhishing', instrumentationContexts);
}
//# sourceMappingURL=markItemsAsPhishingFromTable.js.map

/***/ }),

/***/ 5615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var confirmMarkAsPhishing_1 = __webpack_require__(3469);
var createItemContextsForDeleteStoreUpdate_1 = __webpack_require__(3114);
var markItemsAsPhishingBasedOnItemIds_1 = __webpack_require__(3470);
var deleteItemsStoreUpdate_1 = __webpack_require__(239);
var owa_mail_store_1 = __webpack_require__(38);
var legacy_1 = __webpack_require__(1);
/**
 * Mark item as phishing from reading pane
 * @param itemId of the item to be marked as phishing
 * @param actionSource that triggers the action
 */
exports.default = legacy_1.select({
    item: function (itemId) { return owa_mail_store_1.mailStore.items.get(itemId); },
})(function markItemsAsPhishingFromReadingPane(itemId, actionSource, state) {
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing_1.default(function () {
        markItemsAsPhishingBasedOnItemIds_1.default([itemId], actionSource, function () {
            var itemContexts = createItemContextsForDeleteStoreUpdate_1.default([itemId]);
            // Dispatch action to update the store state
            deleteItemsStoreUpdate_1.default(itemContexts, state.item.ParentFolderId.Id);
        });
    });
});
//# sourceMappingURL=markItemAsPhishingFromReadingPane.js.map

/***/ }),

/***/ 5616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var restoreConversationService_1 = __webpack_require__(3814);
var datapoints_1 = __webpack_require__(2625);
var owa_mail_list_store_1 = __webpack_require__(5);
var Store_1 = __webpack_require__(25);
var actionTypes_1 = __webpack_require__(74);
var owa_service_error_1 = __webpack_require__(152);
var owa_mail_strings_1 = __webpack_require__(22);
var legacy_1 = __webpack_require__(1);
var stitch_1 = __webpack_require__(44);
var filterConversationRowsByRestriction_1 = __webpack_require__(710);
var RestoreConversationActionName = 'RestoreConversation';
/**
 * Restore conversations action
 * @param rowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param state the RestoreConversationState which contains the original table view
 * @return the action response
 */
exports.default = legacy_1.select({
    originalTableView: function (conversationRowKeys, tableViewId) {
        return Store_1.default.tableViews.get(tableViewId);
    },
})(legacy_1.action(RestoreConversationActionName, datapoints_1.default.restoreConversationDatapoint)(function restoreConversations(conversationRowKeys, tableViewId, state) {
    var filteredRowKeys = filterConversationRowsByRestriction_1.default(conversationRowKeys, tableViewId, function (tableConversationRelation) { return !!tableConversationRelation; });
    var conversationIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(filteredRowKeys, tableViewId);
    var conversationActionContexts = filteredRowKeys.map(function (rowKey) {
        return owa_mail_list_store_1.getApplyConversationActionContext(rowKey, tableViewId);
    });
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = owa_service_error_1.handleServiceError(RestoreConversationActionName, owa_mail_strings_1.default.errorRestore, function () {
        var sourceFolderId = state.originalTableView.serverFolderId;
        // Make service request
        return restoreConversationService_1.default(conversationActionContexts, sourceFolderId);
    });
    // raise stitch to delete conversation from reading pane, but not undo because we are not in delete items when undoing
    stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, state.originalTableView);
    return actionResponse;
}));
//# sourceMappingURL=restoreConversation.js.map

/***/ }),

/***/ 5617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getItemIdsFromConversations_1 = __webpack_require__(3194);
var Store_1 = __webpack_require__(25);
var actionTypes_1 = __webpack_require__(74);
var setConversationInferenceClassificationService_1 = __webpack_require__(5618);
var undoActions = __webpack_require__(214);
var legacy_1 = __webpack_require__(1);
var stitch_1 = __webpack_require__(44);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_mail_feature_flags_1 = __webpack_require__(23);
var owa_analytics_1 = __webpack_require__(12);
var owa_mail_inference_tracking_1 = __webpack_require__(3827);
var datapoints_1 = __webpack_require__(2625);
var owa_mail_list_store_2 = __webpack_require__(5);
/**
 * move to focused/other action
 * @param conversationRowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param actionSource the source that initiated this action
 * @return the action response
 */
exports.default = legacy_1.action('moveConversationToFocusedOrOtherAction', datapoints_1.default.moveConversationToFocusedOrOther)(function moveConversationToFocusedOrOther(conversationRowKeys, tableViewId, actionSource) {
    var tableView = Store_1.default.tableViews.get(tableViewId);
    var focusedViewFilter = owa_mail_list_store_1.getFocusedFilterForTable(tableView);
    var isFocusedView = focusedViewFilter == 0 /* Focused */;
    var conversationIdStrings = owa_mail_list_store_2.getRowIdsFromRowKeys(conversationRowKeys, tableViewId);
    undoActions.clearLastUndoableAction();
    setConversationInferenceClassificationService_1.setConversationInferenceClassificationService(conversationIdStrings, isFocusedView ? 'Other' : 'Focused');
    if (owa_mail_feature_flags_1.isMailFeatureEnabled('tri-nonSubstrateInference')) {
        var itemIdsToLog_1 = getItemIdsFromConversations_1.default(conversationRowKeys, tableViewId);
        var activityTime_1 = new Date().toISOString();
        owa_mail_inference_tracking_1.lazyBuildInferenceDatapoint.import().then(function (buildInferenceDatapoint) {
            owa_analytics_1.lazyLogCustomDataLoggerDatapoint.importAndExecute(buildInferenceDatapoint(tableView.serverFolderId, focusedViewFilter, activityTime_1, isFocusedView ? "MarkAsOther" /* MarkAsOther */ : "MarkAsFocused" /* MarkAsFocused */, itemIdsToLog_1));
        });
    }
    // raise stitch to delete conversation from list view and reading pane
    // VSO 20053:Tombstone not working when moving conversation from focused to other
    stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, tableView);
});
//# sourceMappingURL=moveConversationToFocusedOrOther.js.map

/***/ }),

/***/ 5618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var applyConversationActionRequest_1 = __webpack_require__(685);
var conversationAction_1 = __webpack_require__(686);
var itemId_1 = __webpack_require__(94);
var applyConversationActionOperation_1 = __webpack_require__(687);
var Utils_1 = __webpack_require__(362);
function createConversationAction(conversationId, inferenceClassification) {
    return conversationAction_1.default({
        Action: 'SetInferenceClassificationState',
        ConversationId: itemId_1.default({ Id: conversationId }),
        InferenceClassification: inferenceClassification,
    });
}
/**
 * Configure the request body
 * @param conversationIds the conversation ids
 * @param inferenceClassification the inferenceClassification value to update
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationIds, inferenceClassification) {
    var conversationActions = conversationIds.map(function (conversationId) {
        return createConversationAction(conversationId, inferenceClassification);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
    });
}
/**
 * Set InferenceClassification service
 * @param conversationIds the conversation ids
 * @param inferenceClassification the inferenceClassification value to update
 * @return the ApplyConversationActionResponseMessage
 */
function setConversationInferenceClassificationService(conversationIds, inferenceClassification) {
    var requestBody = configureRequestBody(conversationIds, inferenceClassification);
    return applyConversationActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.setConversationInferenceClassificationService = setConversationInferenceClassificationService;
//# sourceMappingURL=setConversationInferenceClassificationService.js.map

/***/ }),

/***/ 5626:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(25);
var undoActions = __webpack_require__(214);
var legacy_1 = __webpack_require__(1);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_mail_feature_flags_1 = __webpack_require__(23);
var owa_analytics_1 = __webpack_require__(12);
var owa_mail_inference_tracking_1 = __webpack_require__(3827);
var datapoints_1 = __webpack_require__(2625);
var deleteItemsStoreUpdate_1 = __webpack_require__(239);
var owa_mail_list_store_2 = __webpack_require__(5);
var Store_2 = __webpack_require__(17);
var setItemsInferenceClassificationService_1 = __webpack_require__(5627);
/**
 * move to focused/other action
 * @param conversationRowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param actionSource the source that initiated this action
 * @return the action response
 */
exports.default = legacy_1.action('moveItemsToFocusedOrOther', datapoints_1.default.moveConversationToFocusedOrOther)(function moveItemsToFocusedOrOther(itemRowKeys, tableViewId, actionSource) {
    var tableView = Store_1.default.tableViews.get(tableViewId);
    var focusedViewFilter = owa_mail_list_store_1.getFocusedFilterForTable(tableView);
    var isFocusedView = focusedViewFilter == 0 /* Focused */;
    var itemIdStrings = owa_mail_list_store_2.getRowIdsFromRowKeys(itemRowKeys, tableViewId);
    undoActions.clearLastUndoableAction();
    var itemContexts = itemIdStrings.map(function (itemIdValue) {
        var item = Store_2.default.items.get(itemIdValue);
        var isReadValue;
        if (owa_mail_list_store_1.isItemOfMessageType(item)) {
            isReadValue = item.IsRead;
        }
        else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
            isRead: isReadValue,
        };
    });
    setItemsInferenceClassificationService_1.default(itemIdStrings, isFocusedView ? 'Other' : 'Focused');
    // Dispatch action to update the store state
    deleteItemsStoreUpdate_1.default(itemContexts, tableView.tableQuery.folderId);
    if (owa_mail_feature_flags_1.isMailFeatureEnabled('tri-nonSubstrateInference')) {
        var activityTime_1 = new Date().toISOString();
        owa_mail_inference_tracking_1.lazyBuildInferenceDatapoint.import().then(function (buildInferenceDatapoint) {
            owa_analytics_1.lazyLogCustomDataLoggerDatapoint.importAndExecute(buildInferenceDatapoint(tableView.serverFolderId, focusedViewFilter, activityTime_1, isFocusedView ? "MarkAsOther" /* MarkAsOther */ : "MarkAsFocused" /* MarkAsFocused */, itemIdStrings));
        });
    }
});
//# sourceMappingURL=moveItemsToFocusedOrOther.js.map

/***/ }),

/***/ 5627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateItemRequest_1 = __webpack_require__(635);
var itemId_1 = __webpack_require__(94);
var itemChange_1 = __webpack_require__(637);
var ServiceRequestUtils_1 = __webpack_require__(31);
var updateItemOperation_1 = __webpack_require__(636);
var createSetItemField_1 = __webpack_require__(639);
function createRequestBody(itemIdsToUpdate, inferenceClassification) {
    var itemChanges = [];
    for (var _i = 0, itemIdsToUpdate_1 = itemIdsToUpdate; _i < itemIdsToUpdate_1.length; _i++) {
        var messageItemId = itemIdsToUpdate_1[_i];
        var update = createSetItemField_1.default('InferenceClassification', inferenceClassification);
        var singleItemChange = itemChange_1.default({
            Updates: [update],
            ItemId: itemId_1.default({
                Id: messageItemId,
            }),
        });
        itemChanges.push(singleItemChange);
    }
    return updateItemRequest_1.default({
        ConflictResolution: 'AlwaysOverwrite',
        ItemChanges: itemChanges,
        OutboundCharset: 'AutoDetect',
    });
}
function setItemsInferenceClassificationService(itemIdsToUpdate, inferenceClassification) {
    var requestBody = createRequestBody(itemIdsToUpdate, inferenceClassification);
    // We want to always set the pin time in UTC time, so it's invariant to user time zone
    var jsonRequestHeader = ServiceRequestUtils_1.getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';
    return updateItemOperation_1.default({
        Header: jsonRequestHeader,
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = setItemsInferenceClassificationService;
//# sourceMappingURL=setItemsInferenceClassificationService.js.map

/***/ }),

/***/ 5628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var alwaysMoveToFocusedOtherService_1 = __webpack_require__(5629);
var owa_confirm_dialog_1 = __webpack_require__(223);
var owa_mail_list_store_1 = __webpack_require__(5);
var createSetItemField_1 = __webpack_require__(639);
var createOrUpdateFocusedOtherOverrideService_1 = __webpack_require__(5631);
var owa_strings_1 = __webpack_require__(20);
var owa_mail_strings_1 = __webpack_require__(22);
var legacy_1 = __webpack_require__(1);
var datapoints_1 = __webpack_require__(2625);
var owa_mail_list_store_2 = __webpack_require__(5);
var moveMailListRowsToFocusedOrOther_1 = __webpack_require__(3826);
/**
 * Always move row from sender to focused/other action
 * @param rowKeys the rowws currently selected
 * @param tableView the table view
 * @param actionSource source of the action
 * @return the action response
 */
exports.default = legacy_1.action('alwaysMoveRowToFocusedOrOtherInternal', datapoints_1.default.alwaysMoveRowToFocusedOrOtherDatapoint)(function alwaysMoveRowToFocusedOrOtherInternal(rowKeys, tableView, actionSource) {
    var senderSMTPAddress = owa_mail_list_store_2.MailRowDataPropertyGetter.getLastSenderSMTP(rowKeys[0], tableView);
    if (senderSMTPAddress == null) {
        return;
    }
    var inferenceClassification;
    var focusedFilter = owa_mail_list_store_1.getFocusedFilterForTable(tableView);
    switch (focusedFilter) {
        case 0 /* Focused */:
            inferenceClassification = 'Other';
            break;
        case 1 /* Other */:
            inferenceClassification = 'Focused';
            break;
        case -1 /* None */:
            throw new Error('FocusedViewFilter.None is not supported for this action');
    }
    // Show confirmation dialog
    owa_confirm_dialog_1.confirm(null, owa_strings_1.format(owa_mail_strings_1.default.alwaysMoveConfirmationText, senderSMTPAddress, inferenceClassification)).then(function (response) {
        if (response === 0 /* ok */) {
            // Since row may have been deleted from the table while the confirm dialog was open,
            // we need to validate the rows again before performing the operation.
            if (tableView.rowKeys.indexOf(rowKeys[0]) > -1) {
                // Only proceed if the selected row hasn't changed
                createOverrideAndSweepRow(rowKeys[0], senderSMTPAddress, inferenceClassification, tableView);
            }
        }
    });
});
/**
 * Create override and sweep row from sender to Focused/Other
 * @param rowKey to be acted upon
 * @param senderSMTPAddress the smtp address of the sender
 * @param inferenceClassification the new inference to set for this sender
 * @param tableView to which row belongs
 */
function createOverrideAndSweepRow(rowKey, senderSMTPAddress, inferenceClassification, tableView) {
    // Move row to Focused or Other
    moveMailListRowsToFocusedOrOther_1.default([rowKey], tableView.id, 'AlwaysMoveToFocusedOther');
    // Create override to move future rows from sender to Focused or Other
    createOrUpdateFocusedOtherOverrideService_1.createOrUpdateFocusedOtherOverrideService(senderSMTPAddress, inferenceClassification);
    // Sweep existing rows from the sender to target Focused or Other
    alwaysMoveToFocusedOtherService_1.alwaysMoveToFocusedOtherService({
        Id: tableView.serverFolderId,
    }, [{ EmailAddress: senderSMTPAddress }], createSetItemField_1.default('InferenceClassification', inferenceClassification));
}
//# sourceMappingURL=alwaysMoveRowToFocusedOrOther.js.map

/***/ }),

/***/ 5629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var applyBulkItemActionOperation_1 = __webpack_require__(3831);
var Utils_1 = __webpack_require__(362);
/**
 * Always move to Focused or Other Service
 * @param sourceFolderId the source folderId
 * @param emailAddresses emailaddresses
 * @param itemPropertytoUpdate the item property to update
 * @return the ApplyBulkItemActionResponse
 */
function alwaysMoveToFocusedOtherService(sourceFolderId, emailAddresses, itemPropertytoUpdate) {
    var requestBody = {
        SourceFolderId: sourceFolderId,
        EmailAddresses: emailAddresses,
        ActionType: 3 /* MoveToFocusedOther */,
        ItemPropertyToUpdate: itemPropertytoUpdate,
    };
    return applyBulkItemActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.alwaysMoveToFocusedOtherService = alwaysMoveToFocusedOtherService;
//# sourceMappingURL=alwaysMoveToFocusedOtherService.js.map

/***/ }),

/***/ 5630:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function applyBulkItemActionJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'ApplyBulkItemActionJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = applyBulkItemActionJsonRequest;


/***/ }),

/***/ 5631:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createOrUpdateFocusedOtherOverrideOperation_1 = __webpack_require__(5632);
var Utils_1 = __webpack_require__(362);
/**
 * Create or Update Focused Other override action service
 * @param senderSMTPAddress sender SMTP address
 * @param inferenceClassification the inferenceClassification
 * @return the CreateOrUpdateFocusedOtherOverrideResponse
 */
function createOrUpdateFocusedOtherOverrideService(senderSMTPAddress, inferenceClassification) {
    var requestBody = {
        SenderSmtpAddress: senderSMTPAddress,
        AlwaysClassifyAs: inferenceClassification,
    };
    return createOrUpdateFocusedOtherOverrideOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.createOrUpdateFocusedOtherOverrideService = createOrUpdateFocusedOtherOverrideService;
//# sourceMappingURL=createOrUpdateFocusedOtherOverrideService.js.map

/***/ }),

/***/ 5632:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var createOrUpdateFocusedOtherOverrideJsonRequest_1 = __webpack_require__(5633);
function createOrUpdateFocusedOtherOverrideOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = createOrUpdateFocusedOtherOverrideJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("CreateOrUpdateFocusedOtherOverride", req, options);
}
exports.default = createOrUpdateFocusedOtherOverrideOperation;


/***/ }),

/***/ 5633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function createOrUpdateFocusedOtherOverrideJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'CreateOrUpdateFocusedOtherOverrideJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = createOrUpdateFocusedOtherOverrideJsonRequest;


/***/ }),

/***/ 5634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_common_strings_1 = __webpack_require__(37);
var datapoints_1 = __webpack_require__(2625);
var deleteItemsStoreUpdate_1 = __webpack_require__(239);
var getItem_1 = __webpack_require__(631);
var getUserConfiguration_1 = __webpack_require__(9);
var itemResponseShape_1 = __webpack_require__(149);
var reportMessageToSafetyLibraryService_1 = __webpack_require__(3825);
var Store_1 = __webpack_require__(17);
var owa_mail_strings_1 = __webpack_require__(22);
var legacy_1 = __webpack_require__(1);
var owa_confirm_dialog_1 = __webpack_require__(223);
var owa_strings_1 = __webpack_require__(20);
var owa_service_error_1 = __webpack_require__(152);
var owa_mail_list_store_1 = __webpack_require__(5);
var UnsubscribeEmailActionName = 'unsubscribeEmail';
// The regular expression of message header of a trusted sender
var TRUSTED_MESSAGE_HEAD_REGX = new RegExp('List-Unsubscribe:[ ]+<mailto:');
/**
 * Perform the unsubscribe action without the confirmation dialog
 * @param message the message
 * @param originalTableView the table view that message belongs to
 * @param isTrustedUnsubscribe whether to set actionData for trusted unsubscribe
 * @param actionSource the user source that initated the action
 */
var unsubscribeWithoutConfirmDialog = legacy_1.action('unsubscribeWithoutConfirmDialog', datapoints_1.default.unsubscribeDatapoint)(function unsubscribeWithoutConfirmDialog(message, originalTableView, isTrustedUnsubscribe, actionSource) {
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = owa_service_error_1.handleServiceError(UnsubscribeEmailActionName, owa_mail_strings_1.default.errorUnsubscribe, function () {
        return reportMessageToSafetyLibraryService_1.default([message.ItemId.Id], 5 /* Unsubscribe */, isTrustedUnsubscribe ? [1] : undefined);
    }, function (isSuccessful) {
        return { isSuccessful: isSuccessful };
    });
    var itemContext = {
        itemId: message.ItemId.Id,
        conversationId: message.ConversationId.Id,
        isRead: message.IsRead,
    };
    deleteItemsStoreUpdate_1.default([itemContext], message.ParentFolderId.Id);
    return actionResponse;
});
/**
 * Show the unsubscribe confirmation dialog
 * @param message the message
 * @param originalTableView the table view
 * @param isTrustedUnsubscribe whether to perform the trusted unsubscribe
 * @param actionSource the user source that initated the action
 * @return a Promise when the action completes
 */
var showUnsubscribeDialog = legacy_1.action('showUnsubscribeDialog')(function showUnsubscribeDialog(message, originalTableView, isTrustedUnsubscribe, actionSource) {
    var _this = this;
    return owa_confirm_dialog_1.confirm(owa_mail_strings_1.default.unsubscribeDialogTitleText, owa_strings_1.format(owa_mail_strings_1.default.unsubscribeDialogSubTitleText, message.From.Mailbox.Name), false /* resolevImmediately */, {
        okText: owa_mail_strings_1.default.unsubscribe,
        cancelText: owa_common_strings_1.default.cancelButton,
    }).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (response === 0 /* ok */) {
                return [2 /*return*/, unsubscribeWithoutConfirmDialog(message, originalTableView, isTrustedUnsubscribe, actionSource)];
            }
            return [2 /*return*/];
        });
    }); });
});
/**
 * Perform the unsubscribe action with the confirmation dialog
 * @param itemId the item id
 * @param tableViewId the table view id
 * @param actionSource the user source that initated the action
 * @param state the state which contains the tableView and reportToExternalSender in user configuration
 */
exports.default = legacy_1.select({
    message: function (itemId, tableViewId) { return Store_1.default.items.get(itemId); },
    originalTableView: function (itemId, tableViewId) {
        return owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    },
    reportToExternalSender: function () { return getUserConfiguration_1.default().SafetyUserOptions.ReportToExternalSender; },
})(legacy_1.action(UnsubscribeEmailActionName)(function unsubscribeEmail(itemId, tableViewId, actionSource, state) {
    var message = state.message, originalTableView = state.originalTableView, reportToExternalSender = state.reportToExternalSender;
    var isMessageLevelSafeOrTrusted = message.MessageSafety &&
        (message.MessageSafety.MessageSafetyLevel == 2 /* Safe */ ||
            message.MessageSafety.MessageSafetyLevel == 1 /* Trusted */);
    if (!reportToExternalSender || !isMessageLevelSafeOrTrusted) {
        // Show confirmation dialog for untrusted sender unsubscribe if reportToExternalSender is not enabled,
        // or the MessageSafetyLevel isn't Safe or Trusted
        return showUnsubscribeDialog(message, originalTableView, false /* isTrustedUnsubscribe */, actionSource);
    }
    var itemShape = itemResponseShape_1.default({
        BaseShape: 'IdOnly',
    });
    // We need to get the headers for this message to test
    // for the List-Unsubscribe before performing a trusted unsubscribe
    return getItem_1.default([message.ItemId.Id], itemShape, 'MessageDetails').then(function (response) {
        if (response[0].ResponseClass == 'Success') {
            var responseItem = response[0];
            var messageHeader = responseItem.Items[0].ExtendedProperty &&
                responseItem.Items[0].ExtendedProperty[0].Value;
            return showUnsubscribeDialog(message, originalTableView, TRUSTED_MESSAGE_HEAD_REGX.test(messageHeader) /* isTrustedUnsubscribe */, actionSource);
        }
        else {
            throw new Error(response[0].MessageText);
        }
    });
}));
//# sourceMappingURL=unsubscribeEmail.js.map

/***/ }),

/***/ 5635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var owa_mail_feature_flags_1 = __webpack_require__(23);
var owa_mail_opt_out_view_1 = __webpack_require__(5636);
var mailOptinUtility_1 = __webpack_require__(2930);
var setClientOptedIn_1 = __webpack_require__(3832);
var getUserConfiguration_1 = __webpack_require__(9);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('clientOptOut', datapoints_1.default.optOutDatapoint)(function clientOptOut(modulePath) {
    setClientOptedIn_1.default(false);
    if (owa_mail_feature_flags_1.isMailFeatureEnabled('usv-forum') && isUserInSample()) {
        owa_mail_opt_out_view_1.lazyShowOptOutDialog.importAndExecute(modulePath);
    }
    else {
        mailOptinUtility_1.optIntoJsmvvmClientAndRedirect(modulePath);
    }
});
function isUserInSample() {
    var upn = getUserConfiguration_1.default().SessionSettings.UserPrincipalName;
    var day = new Date().toDateString();
    var hash = djb2a(day + upn);
    return hash % 10 === 0;
}
function djb2a(key) {
    var hash = 5381;
    for (var i = 0; i < key.length; i++) {
        hash = (hash * 33) ^ key.charCodeAt(i);
    }
    return hash >>> 0;
}
//# sourceMappingURL=clientOptOut.js.map

/***/ }),

/***/ 5636:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
owa_bundling_1.preloadScriptChunk('OptOutDialog');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 5637));
});
exports.lazyShowOptOutDialog = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.showOptOutDialog; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var alwaysDeleteConversationsService_1 = __webpack_require__(5643);
var createSweepRuleForSenderService_1 = __webpack_require__(5645);
var owa_mail_sweep_store_1 = __webpack_require__(2220);
var folderNameToId_1 = __webpack_require__(35);
var legacy_1 = __webpack_require__(1);
/**
 * The keepNParametersTable is used to hold the keepN parameters that used for
 * ApplyBulkItemAction and CreateSweepRuleForSenderAction
 */
var keepNParametersTable = {};
keepNParametersTable[owa_mail_sweep_store_1.SweepOptionType.All] = { keepNType: 1 /* Items */, keepNCount: 0 };
keepNParametersTable[owa_mail_sweep_store_1.SweepOptionType.AllCurrentAndFuture] = {
    keepNType: 1 /* Items */,
    keepNCount: 0,
};
keepNParametersTable[owa_mail_sweep_store_1.SweepOptionType.AllButOne] = { keepNType: 1 /* Items */, keepNCount: 1 };
keepNParametersTable[owa_mail_sweep_store_1.SweepOptionType.AllOlderThan] = { keepNType: 0 /* Days */, keepNCount: 10 };
/**
 * Get the keep n parameters from the table
 * @param sweepOptionType the sweep option type
 */
function getKeepNParameters(sweepOptionType) {
    return keepNParametersTable[sweepOptionType];
}
/**
 * Perform the sweep conversations action
 * @param sweepableMailboxes the sweepable mailboxes (ie not your own mailbox)
 * @param tableView the table view
 * @param sweepOptionType the sweep option type
 */
exports.default = legacy_1.action('sweepConversations')(function sweepConversations(sweepableMailboxes, tableView, sweepOptionType) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, keepNType, keepNCount, destinationFolderId, sourceFolderId;
        return tslib_1.__generator(this, function (_b) {
            _a = getKeepNParameters(sweepOptionType), keepNType = _a.keepNType, keepNCount = _a.keepNCount;
            destinationFolderId = folderNameToId_1.default('deleteditems');
            sourceFolderId = tableView.tableQuery.folderId;
            alwaysDeleteConversationsService_1.default(sweepableMailboxes, destinationFolderId, sourceFolderId, keepNType, keepNCount);
            if (sweepOptionType == owa_mail_sweep_store_1.SweepOptionType.All) {
                // No sweep rule needs to be created if sweep operation is to delete all emails from a sender.
                // In that case, just dismiss the dialog
                return [2 /*return*/];
            }
            else {
                // Show 'Creating...' dialog
                owa_mail_sweep_store_1.setSweepRequestStatus(1 /* Pending */);
            }
            return [2 /*return*/, createSweepRuleForSenderService_1.default(sweepableMailboxes, destinationFolderId, sourceFolderId, keepNType, keepNCount)
                    .then(function (response) {
                    if (response.ResponseMessages.Items[0].ResponseClass == 'Success') {
                        // Show complete dialog if request succeeds
                        owa_mail_sweep_store_1.setSweepRequestStatus(2 /* Complete */);
                    }
                })
                    .catch(function () {
                    // Show error dialog if request fails
                    owa_mail_sweep_store_1.setSweepRequestStatus(3 /* Error */);
                })];
        });
    });
});
//# sourceMappingURL=sweepConversations.js.map

/***/ }),

/***/ 5643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var applyBulkItemActionOperation_1 = __webpack_require__(3831);
var Utils_1 = __webpack_require__(362);
var applyBulkItemActionRequest_1 = __webpack_require__(5644);
/**
 * Always delete conversation Service
 * @param sourceFolderId the source folderId
 * @param emailAddresses emailaddresses
 * @param itemPropertytoUpdate the item property to update
 * @return the ApplyBulkItemActionResponse
 */
function alwaysDeleteConversationsService(emailAddresses, destinationFolderId, sourceFolderId, keepNType, keepNCount) {
    var requestBody = applyBulkItemActionRequest_1.default({
        ActionType: 0 /* Move */,
        DestinationFolderId: { Id: destinationFolderId },
        EmailAddresses: emailAddresses,
        SourceFolderId: { Id: sourceFolderId },
        CountType: keepNType,
        KeepNCount: keepNCount,
    });
    return applyBulkItemActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = alwaysDeleteConversationsService;
//# sourceMappingURL=alwaysDeleteConversationsService.js.map

/***/ }),

/***/ 5644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function applyBulkItemActionRequest(data) {
    var result = tslib_1.__assign({ __type: 'ApplyBulkItemActionRequest:#Exchange' }, data);
    return result;
}
exports.default = applyBulkItemActionRequest;


/***/ }),

/***/ 5645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createSweepRuleForSenderRequest_1 = __webpack_require__(3833);
var createSweepRuleForSenderOperation_1 = __webpack_require__(3834);
var Utils_1 = __webpack_require__(362);
var owa_strings_1 = __webpack_require__(20);
var owa_mail_strings_1 = __webpack_require__(22);
/**
 * Helper function to create the empty rule names array which has the same length of the emailAddresses array.
 * This is a workaround for server validation and will be removed after fixing
 * VSO 8796: Improve validation for utah CreateSweepRuleForSenderAction
 */
function createRuleNames(emailAddresses) {
    return emailAddresses.map(function (email) {
        return owa_strings_1.format(owa_mail_strings_1.default.messagesFrom, email.Name);
    });
}
/**
 * Create sweep rule for sender service request
 * @param emailAddresses the email addresses to be blocked
 * @return the ApplyBulkItemActionResponse
 */
function createSweepRuleForSenderService(emailAddresses, destinationFolderId, sourceFolderId, keepNType, keepNCount) {
    var requestBody = createSweepRuleForSenderRequest_1.default({
        EmailAddresses: emailAddresses,
        ActionType: 0 /* Move */,
        RuleName: null /* deprecated required param*/,
        RuleNames: createRuleNames(emailAddresses),
        SourceFolderId: { Id: sourceFolderId },
        DestinationFolderId: { Id: destinationFolderId },
        CountType: keepNType,
        KeepNCount: keepNCount,
    });
    return createSweepRuleForSenderOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = createSweepRuleForSenderService;
//# sourceMappingURL=createSweepRuleForSenderService.js.map

/***/ }),

/***/ 5646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function createSweepRuleForSenderJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'CreateSweepRuleForSenderJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = createSweepRuleForSenderJsonRequest;


/***/ }),

/***/ 5647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_strings_1 = __webpack_require__(22);
var owa_strings_1 = __webpack_require__(20);
var owa_bulk_action_store_1 = __webpack_require__(1720);
var bulkTriageConstants_1 = __webpack_require__(3147);
var owa_trace_1 = __webpack_require__(14);
/**
 * Gets the confirm text for delete all dialog.
 * @param actionSource Action that initiated the delete all action
 * @param listViewType The view type of the folder being deleted
 * @param totalCount The total count of items in folder
 * @returns The text shown in delete all confirmation dialog
 */
function getDeleteAllConfirmText(actionSource, listViewType, totalCount, folder) {
    var isMessageView = listViewType === 1 /* Message */;
    /**
     * Special-case "ContextFolder" because the TotalCount received from the
     * Folder object is always message count.
     */
    var useItemStrings = actionSource === 'ContextFolder' || isMessageView;
    if (totalCount == 0) {
        owa_trace_1.trace.warn('getDeleteAllConfirmText should not be called.');
        return '';
    }
    else {
        owa_bulk_action_store_1.lazyOnBulkActionSubmitted.importAndExecute(folder, totalCount);
        if (totalCount == 1) {
            return owa_mail_strings_1.default.deleteItem;
        }
        else if (totalCount < bulkTriageConstants_1.MAX_LABEL_ITEM_COUNT) {
            return useItemStrings
                ? owa_strings_1.format(owa_mail_strings_1.default.deleteNumberOfItems, totalCount)
                : owa_strings_1.format(owa_mail_strings_1.default.deleteNumberOfConversations, totalCount);
        }
        else {
            return useItemStrings
                ? owa_strings_1.format(owa_mail_strings_1.default.deleteNumberOfItems, '10000+')
                : owa_strings_1.format(owa_mail_strings_1.default.deleteNumberOfConversations, '10000+');
        }
    }
}
exports.default = getDeleteAllConfirmText;
//# sourceMappingURL=getDeleteAllConfirmText.js.map

/***/ }),

/***/ 5648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var emptyFolderOperation_1 = __webpack_require__(5649);
var emptyFolderRequest_1 = __webpack_require__(5651);
var folderId_1 = __webpack_require__(47);
var distinguishedFolderId_1 = __webpack_require__(97);
/* tslint:disable:restrict-import-path */
var getUserConfiguration_1 = __webpack_require__(9);
/* tslint:enable:restrict-import-path */
var isSharedFolder_1 = __webpack_require__(3285);
var ServiceRequestUtils_1 = __webpack_require__(31);
var folderIdToName_1 = __webpack_require__(48);
var itemId_1 = __webpack_require__(94);
var owa_mail_feature_flags_1 = __webpack_require__(23);
/**
 * Create and submit the empty folder action for the specified folder
 * @param folder the folder to be emptied
 * @param disposalType the disposal type
 * @param deleteSubFolder whether to delete subfolder
 * @param clientLastSyncTime the client last sync time watermark
 * @param itemIdsToExclude item ids to exclude from empty folder operation
 */
function emptyFolderService(folder, disposalType, deleteSubFolder, clientLastSyncTime, itemIdsToExclude) {
    var requestBody = configureRequestBody(folder, disposalType, deleteSubFolder, clientLastSyncTime, itemIdsToExclude);
    return emptyFolderOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.emptyFolderService = emptyFolderService;
/**
 * Configure the empty folder request body
 * @param folder the folder to be emptied
 * @param disposalType the disposal type
 * @param deleteSubFolder whether to delete subfolder
 * @param clientLastSyncTime the client last sync time watermark
 * @param itemIdsToExclude item ids to exclude from empty folder operation
 */
function configureRequestBody(folder, disposalType, deleteSubFolder, clientLastSyncTime, itemIdsToExclude) {
    var folderIdToEmpty = null;
    var distinguishedFolderIdName = folderIdToName_1.default(folder.FolderId.Id);
    folderIdToEmpty =
        distinguishedFolderIdName == 'none'
            ? folderId_1.default({ Id: folder.FolderId.Id })
            : distinguishedFolderId_1.default({ Id: distinguishedFolderIdName });
    var baseItemIds = itemIdsToExclude != undefined ? itemIdsToExclude.map(function (id) { return itemId_1.default({ Id: id }); }) : undefined;
    var body = emptyFolderRequest_1.default({
        FolderIds: [folderIdToEmpty],
        AllowSearchFolder: true,
        DeleteType: disposalType,
        DeleteSubFolders: deleteSubFolder,
        SuppressReadReceipt: getUserConfiguration_1.default().UserOptions.ReadReceipt != 'AlwaysSend' ||
            isSharedFolder_1.default(folder.FolderId.Id),
        ItemIdsToExclude: baseItemIds,
        BulkActionRequest: owa_mail_feature_flags_1.isMailFeatureEnabled('tri-bulkActionNotification'),
    });
    // Server does not support specify ClientLastSyncTime and deleting subfolders at the same time
    if (deleteSubFolder && clientLastSyncTime) {
        throw new Error('ClientLastSyncTime is not supported when deleting subfolders.');
    }
    // Specify ClientLastSyncTime if not delete sub folders
    if (!deleteSubFolder) {
        body.ClientLastSyncTime = clientLastSyncTime && clientLastSyncTime.toISOString();
    }
    return body;
}
//# sourceMappingURL=emptyFolderService.js.map

/***/ }),

/***/ 5649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var emptyFolderJsonRequest_1 = __webpack_require__(5650);
function emptyFolderOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = emptyFolderJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("EmptyFolder", req, options);
}
exports.default = emptyFolderOperation;


/***/ }),

/***/ 5650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function emptyFolderJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'EmptyFolderJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = emptyFolderJsonRequest;


/***/ }),

/***/ 5651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function emptyFolderRequest(data) {
    var result = tslib_1.__assign({ __type: 'EmptyFolderRequest:#Exchange' }, data);
    return result;
}
exports.default = emptyFolderRequest;


/***/ }),

/***/ 5652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var deleteMailListRows_1 = __webpack_require__(3467);
function emptySearchTableView(tableView) {
    return deleteMailListRows_1.default(tableView.rowKeys, tableView.id, false /* isExplicitSoftDelete */);
}
exports.default = emptySearchTableView;
//# sourceMappingURL=emptySearchTableView.js.map

/***/ }),

/***/ 5653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var emptyFolder_1 = __webpack_require__(3835);
var owa_mail_list_store_1 = __webpack_require__(5);
var Store_1 = __webpack_require__(17);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('emptyTableView')(legacy_1.select({
    folderToBeEmptied: function (tableViewToBeEmptied) {
        return Store_1.default.folders.folderTable.get(tableViewToBeEmptied.tableQuery.folderId);
    },
})(function emptyTableView(tableViewToBeEmptied, isExplicitSoftDelete, actionSource, rowKeysToExclude, state) {
    var folderToBeEmptied = state.folderToBeEmptied;
    // User server folder id for empty table view if it's not deleteditems or junkemail.
    // For deleteditems or junkemail, they don't support delete all with a viewFilter specified.
    if (folderToBeEmptied.distinguishedFolderId == 'deleteditems' ||
        folderToBeEmptied.distinguishedFolderId == 'junkemail') {
        emptyFolder_1.default(folderToBeEmptied, -1 /* None */, 'All', isExplicitSoftDelete, actionSource, rowKeysToExclude, tableViewToBeEmptied.selectAllModeTimeStamp, tableViewToBeEmptied.id);
    }
    else {
        // Copy properties from folderToBeEmptied to folder
        var folder = tslib_1.__assign({}, folderToBeEmptied);
        folder.FolderId = {
            Id: tableViewToBeEmptied.serverFolderId,
        };
        folder.TotalCount = tableViewToBeEmptied.totalRowsInView;
        emptyFolder_1.default(folder, owa_mail_list_store_1.getFocusedFilterForTable(tableViewToBeEmptied), owa_mail_list_store_1.getViewFilterForTable(tableViewToBeEmptied), isExplicitSoftDelete, actionSource, rowKeysToExclude, tableViewToBeEmptied.selectAllModeTimeStamp, tableViewToBeEmptied.id);
    }
}));
//# sourceMappingURL=emptyTableView.js.map

/***/ }),

/***/ 5654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var markItemsJunkNotJunkFromTable_1 = __webpack_require__(5655);
var markConversationsJunkNotJunkFromTable_1 = __webpack_require__(5660);
/**
 * Mark the rows as junk or not junk
 * @param rowKeys of the rows to be marked as junk/not junk
 * @param tableView that contains the rows
 * @param isJunkValueToSet whether to mark as junk or not junk
 * @param actionSource the action source
 */
function markRowsJunkNotJunkFromTable(rowKeys, tableView, isJunkValueToSet, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            markConversationsJunkNotJunkFromTable_1.default(rowKeys, tableView, isJunkValueToSet, actionSource);
            break;
        case 1 /* Message */:
            markItemsJunkNotJunkFromTable_1.default(rowKeys, tableView, isJunkValueToSet, actionSource);
            break;
    }
}
exports.default = markRowsJunkNotJunkFromTable;
//# sourceMappingURL=markRowsJunkNotJunkFromTable.js.map

/***/ }),

/***/ 5655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createItemContextsForDeleteStoreUpdate_1 = __webpack_require__(3114);
var deleteItemsStoreUpdate_1 = __webpack_require__(239);
var getInstrumentationContextsFromTableView_1 = __webpack_require__(215);
var markItemsJunkNotJunkBasedOnItemIds_1 = __webpack_require__(3472);
var owa_mail_list_store_1 = __webpack_require__(5);
/**
 * The action which marks items as junk.
 * @param itemRowKeys - the rows to mark as junk
 * @param tableView - the table view the items are from
 * @param isJunkValueToSet - whether it is a mark as junk or not junk action
 * @param actionSource - where the action is triggered from
 */
function markItemsJunkNotJunkFromTable(itemRowKeys, tableView, isJunkValueToSet, actionSource) {
    var itemIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(itemRowKeys, tableView.id);
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(itemRowKeys, tableView);
    markItemsJunkNotJunkBasedOnItemIds_1.default(itemIdStrings, isJunkValueToSet, actionSource, instrumentationContexts, function () {
        var itemContexts = createItemContextsForDeleteStoreUpdate_1.default(itemIdStrings);
        // Dispatch action to update the store state
        deleteItemsStoreUpdate_1.default(itemContexts, tableView.tableQuery.folderId);
    });
}
exports.default = markItemsJunkNotJunkFromTable;
//# sourceMappingURL=markItemsJunkNotJunkFromTable.js.map

/***/ }),

/***/ 5656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getServiceItemIds_1 = __webpack_require__(3193);
var markAsJunkRequest_1 = __webpack_require__(5657);
var markAsJunkOperation_1 = __webpack_require__(5658);
var ServiceRequestUtils_1 = __webpack_require__(31);
var owa_mail_strings_1 = __webpack_require__(22);
/**
 * Configure the mark as junk/not junk request Body
 * @param itemIdsToUpdate an array of the item id strings to be updated
 * @param isJunk whether it is a mark as junk action or not
 * @return the request body for mark as junk service request
 */
function configureRequestBody(itemIdsToUpdate, isJunk) {
    var markAsJunkRequestData = {
        ItemIds: getServiceItemIds_1.default(itemIdsToUpdate),
        IsJunk: isJunk,
        MoveItem: true,
        SendCopy: false,
        JunkMessageHeader: owa_mail_strings_1.default.junkMessageHeader,
        JunkMessageBody: owa_mail_strings_1.default.junkMessageBody,
    };
    return markAsJunkRequest_1.default(markAsJunkRequestData);
}
/**
 * Submit the mark as junk service request
 * @param itemIds the item ids to be updated
 * @param isJunk whether it is a mark as junk action or not
 * @return the MarkAsJunkResponseMessage
 */
function markConversationAsJunkService(itemIdsToUpdate, isJunk) {
    var requestBody = configureRequestBody(itemIdsToUpdate, isJunk);
    return markAsJunkOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = markConversationAsJunkService;
//# sourceMappingURL=markAsJunkService.js.map

/***/ }),

/***/ 5657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function markAsJunkRequest(data) {
    var result = tslib_1.__assign({ __type: 'MarkAsJunkRequest:#Exchange' }, data);
    return result;
}
exports.default = markAsJunkRequest;


/***/ }),

/***/ 5658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var markAsJunkJsonRequest_1 = __webpack_require__(5659);
function markAsJunkOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = markAsJunkJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("MarkAsJunk", req, options);
}
exports.default = markAsJunkOperation;


/***/ }),

/***/ 5659:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function markAsJunkJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'MarkAsJunkJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = markAsJunkJsonRequest;


/***/ }),

/***/ 5660:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getInstrumentationContextsFromTableView_1 = __webpack_require__(215);
var getItemIdsFromConversations_1 = __webpack_require__(3194);
var markItemsJunkNotJunkBasedOnItemIds_1 = __webpack_require__(3472);
var actionTypes_1 = __webpack_require__(74);
var owa_mail_list_store_1 = __webpack_require__(5);
var stitch_1 = __webpack_require__(44);
/**
 * The action which marks conversations as junk.
 * @param conversationRowKeys - the conversations rows to mark as junk
 * @param tableView - the table view the conversations are from
 * @param isJunkValueToSet - whether it is a mark as junk or not junk action
 * @param actionSource - the source that initiated the action call
 */
function markConversationsJunkNotJunkFromTable(conversationRowKeys, tableView, isJunkValueToSet, actionSource) {
    // the itemIds need to be retrieved before the store update, otherwise it might get removed
    var itemIdsToUpdate = getItemIdsFromConversations_1.default(conversationRowKeys, tableView.id);
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(conversationRowKeys, tableView);
    markItemsJunkNotJunkBasedOnItemIds_1.default(itemIdsToUpdate, isJunkValueToSet, actionSource, instrumentationContexts, function () {
        // remove conversation from list view and reading pane store
        var conversationIds = owa_mail_list_store_1.getRowIdsFromRowKeys(conversationRowKeys, tableView.id);
        stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIds, tableView);
    });
}
exports.default = markConversationsJunkNotJunkFromTable;
//# sourceMappingURL=markConversationsJunkNotJunkFromTable.js.map

/***/ }),

/***/ 5661:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createItemContextsForDeleteStoreUpdate_1 = __webpack_require__(3114);
var markItemsJunkNotJunkBasedOnItemIds_1 = __webpack_require__(3472);
var deleteItemsStoreUpdate_1 = __webpack_require__(239);
var Store_1 = __webpack_require__(17);
var doesFolderIdEqualName_1 = __webpack_require__(682);
var legacy_1 = __webpack_require__(1);
/**
 * Mark item as junk/not junk
 * @param itemIds the specified item Ids to be marked as junk
 * @param actionSource the source that initiated the action
 * @param state the MarkItemJunkNotJunkFromReadingPaneState which contains the original table view
 */
exports.default = legacy_1.select({
    item: function (itemId) { return Store_1.default.items.get(itemId); },
})(function markItemJunkNotJunkFromReadingPane(itemId, actionSource, instrumentationContexts, state) {
    var item = state.item;
    var isJunkFolder = doesFolderIdEqualName_1.default(item.ParentFolderId.Id, 'junkemail');
    markItemsJunkNotJunkBasedOnItemIds_1.default([itemId], !isJunkFolder /* isJunkValueToSet*/, actionSource, instrumentationContexts, function () {
        var itemContexts = createItemContextsForDeleteStoreUpdate_1.default([itemId]);
        // Dispatch action to update the store state
        deleteItemsStoreUpdate_1.default(itemContexts, item.ParentFolderId.Id);
    });
});
//# sourceMappingURL=markItemJunkNotJunkFromReadingPane.js.map

/***/ }),

/***/ 5662:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var deleteConversations_1 = __webpack_require__(3812);
var deleteItems_1 = __webpack_require__(3192);
var blockLastSendersHelper_1 = __webpack_require__(3836);
var getSweepableMailboxes_1 = __webpack_require__(2252);
var getUniqueConversationContextsForRowKey_1 = __webpack_require__(3815);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_trace_1 = __webpack_require__(14);
var legacy_1 = __webpack_require__(1);
var getInstrumentationContextsFromTableView_1 = __webpack_require__(215);
/**
 * Block the smtp addresses from given rows
 * @param rowKeys the row keys
 * @param tableView the table view
 * @param actionSource the action source that triggers the block action
 */
function blockLastSendersFromTable(rowKeys, tableView, actionSource) {
    if (!rowKeys || rowKeys.length == 0) {
        owa_trace_1.trace.error('Block button should not be exposed when there is nothing selected in list view.');
        return;
    }
    // Get de-duped mailboxes
    var mailboxes = getSweepableMailboxes_1.getSweepableMailboxesFromRowKeys(rowKeys, tableView);
    blockLastSendersHelper_1.default(mailboxes, function () {
        deleteRowsUponBlocking(rowKeys, tableView, actionSource);
    });
}
exports.default = blockLastSendersFromTable;
/**
 * Delete the rows after the block last senders
 * @param rowKeys of the rows where the last senders are retrieved from
 * @param tableView that contains the rows
 */
var deleteRowsUponBlocking = legacy_1.action('deleteRowsUponBlocking', datapoints_1.default.blockSendersFromTableDatapoint)(function deleteRowsUponBlocking(rowKeys, tableView, actionSource) {
    // Since conversations may have been deleted from the table while the confirm dialog was open,
    // we need to validate the conversation rowKeys again before performing delete
    var filteredRowKeys = rowKeys.filter(function (rowKey) { return tableView.rowKeys.indexOf(rowKey) >= 0; });
    var disposableType = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl')
        ? 'HardDelete'
        : 'MoveToDeletedItems';
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            var conversationActionContexts = getUniqueConversationContextsForRowKey_1.default(filteredRowKeys, tableView.id);
            // VSO: 20069: [Discussion] Block Senders on a conversation
            // Permanently delete selected emails
            deleteConversations_1.deleteConversationsWithoutConfirmDialog(conversationActionContexts, tableView.id, disposableType, instrumentationContexts, 'NonUserAction' /* actionSource */);
            break;
        case 1 /* Message */:
            var itemIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, tableView.id);
            deleteItems_1.deleteItemsWithoutConfirmDialog(itemIdStrings, disposableType, tableView.tableQuery.folderId, 'NonUserAction' /* actionSource */, instrumentationContexts, null /* requestInitOptions */);
            break;
    }
});
//# sourceMappingURL=blockLastSendersFromTable.js.map

/***/ }),

/***/ 5663:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_strings_1 = __webpack_require__(20);
var owa_mail_strings_1 = __webpack_require__(22);
function getBlockSendersConfirmTitleAndSubtext(emailAddresses) {
    return [title(emailAddresses), subtext(emailAddresses)];
}
exports.default = getBlockSendersConfirmTitleAndSubtext;
function title(emailAddresses) {
    return formatSenders(emailAddresses, function (e) { return e.Name; }, owa_mail_strings_1.default.blockSendersTitle, owa_mail_strings_1.default.blockTwoSendersTitle, owa_mail_strings_1.default.blockThreeSendersTitle, owa_mail_strings_1.default.blockFourToSixSendersTitle, owa_mail_strings_1.default.blockSevenOrMoreSendersTitle);
}
function subtext(emailAddresses) {
    return formatSenders(emailAddresses, function (e) { return e.EmailAddress; }, owa_mail_strings_1.default.blockSendersSubtext, owa_mail_strings_1.default.blockTwoSendersSubtext, owa_mail_strings_1.default.blockThreeSendersSubtext, owa_mail_strings_1.default.blockFourToSixSendersSubtext, owa_mail_strings_1.default.blockSevenOrMoreSendersSubtext);
}
function formatSenders(emailAddresses, toText, oneSender, twoSenders, threeSenders, fourToSixSenders, sevenOrMoreSenders) {
    switch (emailAddresses.length) {
        case 0:
            throw new Error('formatSenders: no email addresses');
        case 1:
            return owa_strings_1.format(oneSender, toText(emailAddresses[0]));
        case 2:
            return owa_strings_1.format(twoSenders, toText(emailAddresses[0]), toText(emailAddresses[1]));
        case 3:
            return owa_strings_1.format(threeSenders, toText(emailAddresses[0]), toText(emailAddresses[1]));
        case 4:
        case 5:
        case 6:
            return owa_strings_1.format(fourToSixSenders, toText(emailAddresses[0]), toText(emailAddresses[1]), emailAddresses.length - 2);
        default:
            return owa_strings_1.format(sevenOrMoreSenders, toText(emailAddresses[0]), toText(emailAddresses[1]), emailAddresses.length - 2);
    }
}
//# sourceMappingURL=getBlockSendersConfirmTitleAndSubtext.js.map

/***/ }),

/***/ 5664:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createSweepRuleForSenderRequest_1 = __webpack_require__(3833);
var createSweepRuleForSenderOperation_1 = __webpack_require__(3834);
var Utils_1 = __webpack_require__(362);
/**
 * Helper function to create the empty rule names array which has the same length of the emailAddresses array.
 * This is a workaround for server validation and will be removed after fixing
 * VSO 8796: Improve validation for utah CreateSweepRuleForSenderAction
 */
function createRuleNames(emailAddresses) {
    return emailAddresses.map(function (email) {
        return '';
    });
}
/**
 * Apply bulk item action service
 * @param emailAddresses the email addresses to be blocked
 * @return the ApplyBulkItemActionResponse
 */
function blockSenderService(emailAddresses) {
    var requestBody = createSweepRuleForSenderRequest_1.default({
        EmailAddresses: emailAddresses,
        ActionType: 2 /* Block */,
        RuleName: null /* deprecated required param*/,
        RuleNames: createRuleNames(emailAddresses),
    });
    return createSweepRuleForSenderOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = blockSenderService;
//# sourceMappingURL=blockSenderService.js.map

/***/ }),

/***/ 5665:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(2625);
var deleteItems_1 = __webpack_require__(3192);
var blockLastSendersHelper_1 = __webpack_require__(3836);
var getSweepableMailboxes_1 = __webpack_require__(2252);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var itemId_1 = __webpack_require__(94);
var owa_trace_1 = __webpack_require__(14);
var legacy_1 = __webpack_require__(1);
/**
 * Block the sender smtp addresses from the given item ids
 * @param itemIdToBlock the item id
 */
function blockLastSenderFromReadingPane(itemId, instrumentationContexts) {
    if (!itemId) {
        owa_trace_1.trace.error('blockLastSendersFromReadingPane should not be called on invalid items.');
        return;
    }
    // De-duped senders
    var mailboxes = getSweepableMailboxes_1.getSweepableMailboxesFromItemIds([itemId]);
    blockLastSendersHelper_1.default(mailboxes, function () {
        deleteItemUponBlock(itemId, instrumentationContexts);
    });
}
exports.default = blockLastSenderFromReadingPane;
var deleteItemUponBlock = legacy_1.action('deleteItemUponBlock', datapoints_1.default.blockSenderFromReadingPaneDatapoint)(function deleteItemUponBlock(itemIdToBlock, instrumentationContexts) {
    var disposalType = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl')
        ? 'HardDelete'
        : 'MoveToDeletedItems';
    return deleteItems_1.deleteItemFromReadingPane(itemId_1.default({ Id: itemIdToBlock }), disposalType, 'NonUserAction' /* actionSource */, instrumentationContexts);
});
//# sourceMappingURL=blockLastSenderFromReadingPane.js.map

/***/ }),

/***/ 5666:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateConversationsCategoriesInternal_1 = __webpack_require__(5667);
var legacy_1 = __webpack_require__(1);
var datapoints_1 = __webpack_require__(2625);
/**
 * Add categories to the specified rows from the table
 * @param rowKeys of the rows to add categories to
 * @param tableView that contains the rows
 * @param categoriesToAdd the categories to be added to the rows
 * @param actionSource the action source
 */
exports.addCategoriesFromTable = legacy_1.action('addCategories', datapoints_1.default.addCategories)(function addCategoriesFromTable(rowKeys, tableView, categoriesToAdd, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            updateConversationsCategoriesInternal_1.default(rowKeys, tableView, categoriesToAdd, null /* categoriesToRemove */, false /* clearCategories */, actionSource);
            break;
        case 1 /* Message */:
            break;
    }
});
/**
 * Clear categories of the specified rows from the table
 * @param rowKeys of the rows to clear categoriesToRemove
 * @param tableView that contains the rows
 * @param actionSource the action source
 */
exports.clearCategoriesFromTable = legacy_1.action('clearCategories', datapoints_1.default.clearCategories)(function clearCategoriesFromTable(rowKeys, tableView, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            updateConversationsCategoriesInternal_1.default(rowKeys, tableView, null /* categoriesToAdd */, null /* categoriesToRemove */, true /* clearCategories */, actionSource);
            break;
        case 1 /* Message */:
            break;
    }
});
/**
 * Remove categories from the specified rows from the table
 * @param rowKeys of the rows to remove categories to
 * @param tableView that contains the rows
 * @param categoriesToRemove the categories to be removed to the rows
 * @param actionSource the action source
 */
exports.removeCategoriesFromTable = legacy_1.action('removeCategoriesFromTable', datapoints_1.default.removeCategories)(function removeCategoriesFromTable(rowKeys, tableView, categoriesToRemove, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            updateConversationsCategoriesInternal_1.default(rowKeys, tableView, null /* categoriesToAdd */, categoriesToRemove, false /* clearCategories */, actionSource);
            break;
        case 1 /* Message */:
            break;
    }
});
//# sourceMappingURL=categoryTriageActions.js.map

/***/ }),

/***/ 5667:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateConversationsCategoriesService_1 = __webpack_require__(5668);
var owa_analytics_1 = __webpack_require__(12);
var conversationsCategoriesStoreUpdate_1 = __webpack_require__(801);
var undoActions = __webpack_require__(214);
var owa_service_error_1 = __webpack_require__(152);
var owa_mail_strings_1 = __webpack_require__(22);
var owa_mail_list_store_1 = __webpack_require__(5);
/**
 * Categorize the conversations from table
 * @param conversationRowKeys to be categorized
 * @param tableView that contain the conversations
 * @param categorizesToAdd the categories to add to the conversations
 * @param categorizesToRemove the categories to be removed from the conversations
 * @param clearCategories a boolean which indicates whether to clear categories for the specified conversations
 * @param actionSource where the action is triggered from
 */
function updateConversationsCategoriesInternal(conversationRowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource) {
    validateCategoryParameters(conversationRowKeys, categoriesToAdd, categoriesToRemove, clearCategories);
    undoActions.clearLastUndoableAction();
    // VSO 23862 - Instrumentation for category triage actions
    owa_service_error_1.handleServiceError('updateConversationsCategoriesInternal', owa_mail_strings_1.default.errorUpdatingCategories, function () {
        var contextFolderId = owa_mail_list_store_1.getContextFolderIdForTable(tableView);
        var conversationActionContexts = conversationRowKeys.map(function (rowKey) {
            return owa_mail_list_store_1.getApplyConversationActionContext(rowKey, tableView.id);
        });
        var datapoint = owa_analytics_1.returnTopExecutingActionDatapoint();
        var promiseToReturn = updateConversationsCategoriesService_1.default(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories).catch(function (e) {
            datapoint.endWithError(owa_analytics_1.DatapointStatus.ServerError);
        });
        // Update the conversation categories in store
        conversationsCategoriesStoreUpdate_1.default(conversationRowKeys, tableView.id, categoriesToAdd, categoriesToRemove, clearCategories);
        return promiseToReturn;
    });
}
exports.default = updateConversationsCategoriesInternal;
/**
 * Validate the update categories parameters
 * @param categoriesToAdd the categories to be added to the conversations
 * @param categoriesToRemove the categories to be removed from the conversations
 * @param clearCategories whether to clear categories
 */
function validateCategoryParameters(conversationRowKeys, categoriesToAdd, categoriesToRemove, clearCategories) {
    if (!conversationRowKeys || conversationRowKeys.length === 0) {
        throw new Error('Update category action should not be exposed.');
    }
    if (clearCategories && (!!categoriesToAdd || !!categoriesToRemove)) {
        throw new Error('When clearCategories is true, categoriesToAdd and categoriesToRemove both have to be null.');
    }
    if (!!categoriesToAdd && !!categoriesToRemove) {
        throw new Error('Can only add or remove categories at one time.');
    }
}
//# sourceMappingURL=updateConversationsCategoriesInternal.js.map

/***/ }),

/***/ 5668:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var applyConversationActionRequest_1 = __webpack_require__(685);
var conversationAction_1 = __webpack_require__(686);
var folderId_1 = __webpack_require__(47);
var itemId_1 = __webpack_require__(94);
var targetFolderId_1 = __webpack_require__(156);
var applyConversationActionOperation_1 = __webpack_require__(687);
var Utils_1 = __webpack_require__(362);
/**
 * Issue the service request to update categories of specified conversations
 * @param conversationActionContexts the conversation context to be categorized
 * @param contextFolderId the context folder id that the conversation belongs to
 * @param categoriesToAdd the categories to be added to the conversations
 * @param categoriesToRemove the categories to be removed from the conversations
 * @param clearCategories whether to clear categories
 * @return a promise which contains ApplyConversationActionResponseMessage
 */
function updateConversationsCategoriesService(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories) {
    var requestBody = configureRequestBody(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories);
    return applyConversationActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = updateConversationsCategoriesService;
/**
 * Configure the ApplyConversationActionRequest
 * @param conversationActionContexts the conversation context to be categorized
 * @param contextFolderId the context folder id that the conversation belongs to
 * @param categoriesToAdd the categories to add to the conversations
 * @param categoriesToRemove the categories to be removed from the conversations
 * @param clearCategories whether to clear categories
 * @return an ApplyConversationActionRequest
 */
function configureRequestBody(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories) {
    var conversationActions = conversationActionContexts.map(function (conversationContext) {
        return createCategorizeConversationAction(conversationContext, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}
/**
 * Configure the ApplyConversationActionRequest
 * @param conversationContext the conversation context to be categorized
 * @param contextFolderId the context folder id that the conversation belongs to
 * @param categoriesToAdd the categories to be added to the conversations
 * @param categoriesToRemove the categories to be removed to the conversations
 * @param clearCategories the categories to be removed to the conversations
 * @return the generated ConversationAction
 */
function createCategorizeConversationAction(conversationContext, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories) {
    var categorizeAction = conversationAction_1.default({
        Action: 'UpdateAlwaysCategorizeRule',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        Categories: categoriesToAdd,
        CategoriesToRemove: categoriesToRemove,
        ClearCategories: clearCategories,
    });
    // folderId can be null in search mode.
    if (contextFolderId) {
        var targetFolderId = targetFolderId_1.default({
            BaseFolderId: folderId_1.default({
                Id: contextFolderId,
            }),
        });
        categorizeAction.ContextFolderId = targetFolderId;
    }
    return categorizeAction;
}
//# sourceMappingURL=updateConversationsCategoriesService.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.TriageAction.js